<template>
  <div>
    <div class="case-spisi">
      <div class="spisi-left">
        <!-- Close case-folders-line -->
        <div class="opening-folder">
          <div class="open-folder-line">
            <div class="open-folder-line-left">
              <div class="folder-tiny-icon">
                <img src="@/assets/img/tiny-folder.png" />
              </div>
              <div class="folder-open-name" v-if="all_files_rec != undefined">
                {{ getFolderName(all_files_rec.item.name) }}
              </div>
              <div v-if="is_permission_inside('edit') && view_name == 'spisi'" class="edit-spis-name add-button add-pen"
                @click="switchTab('spisi/' + selected_spis.id_spis + '/edit')">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                  <g>
                    <g>
                      <path fill="#7b7b8a"
                        d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z" />
                    </g>
                  </g>
                </svg>
              </div>
            </div>
            <div class="open-folder-line-right">
              <filter-tag-switch :filtered_doc_number="12" @filter_change="filterSwitched" />
              <div class="open-folder-line-sort svg-name active" @click="reverseSmjer(0)" id="name-filter">
                {{ $t("page_2.page_2_3.f1") }} {{ $t('components.general.file_management.tree_viewer.order_by_text') }}
                <svg v-if="smjer" xmlns="http://www.w3.org/2000/svg" width="45" height="20" viewBox="0 0 45 20"
                  class="svg-name-to-rotate">
                  <path
                    d="M4.1448 12.8692H5.3L5.3 3.52032C5.3009 3.44154 5.3317 3.36634 5.38566 3.31117C5.43963 3.25599 5.51236 3.22534 5.58795 3.22591H7.91198C7.94949 3.22544 7.98672 3.23269 8.02155 3.24724C8.05637 3.26179 8.08809 3.28336 8.1149 3.31071C8.14171 3.33805 8.16309 3.37065 8.17779 3.40662C8.1925 3.44258 8.20025 3.48122 8.20061 3.52032L8.20061 12.8692H9.35445C9.40849 12.8689 9.46151 12.8845 9.50748 12.9141C9.55345 12.9436 9.59053 12.9861 9.61449 13.0366C9.63801 13.0865 9.64718 13.1425 9.6409 13.1977C9.63462 13.253 9.61316 13.3052 9.57909 13.348L6.97461 17.3109C6.94717 17.3451 6.9128 17.3726 6.87396 17.3914C6.83512 17.4102 6.79278 17.4197 6.74997 17.4194C6.66283 17.4194 6.57978 17.3797 6.52532 17.3102L5.22308 15.3287L3.92084 13.3473C3.88678 13.3045 3.86531 13.2523 3.85903 13.197C3.85275 13.1418 3.86192 13.0858 3.88544 13.0359C3.9094 12.9854 3.94648 12.9429 3.99245 12.9133C4.03842 12.8837 4.09144 12.8682 4.14548 12.8684L4.1448 12.8692Z"
                    fill="#3326AE" />
                  <path
                    d="M13.4579 16.2903H11.9806L16.2534 4.65392H17.7079L21.9806 16.2903H20.5034L17.0261 6.49483H16.9352L13.4579 16.2903ZM14.0034 11.7448H19.9579V12.9948H14.0034V11.7448ZM28.6113 9.8471V11.0971H23.5204V9.8471H28.6113ZM30.7661 16.2903V15.2676L37.0389 5.90392H30.698V4.65392H38.7207V5.67665L32.448 15.0403H38.7889V16.2903H30.7661Z"
                    fill="#3326AE" />
                </svg>

                <svg v-else xmlns="http://www.w3.org/2000/svg" width="45" height="20" viewBox="0 0 45 20">
                  <path
                    d="M9.3552 7.77611H8.2V17.1249C8.1991 17.2037 8.1683 17.2789 8.11434 17.3341C8.06037 17.3893 7.98764 17.4199 7.91205 17.4194H5.58802C5.55051 17.4198 5.51328 17.4126 5.47845 17.398C5.44363 17.3835 5.41191 17.3619 5.3851 17.3346C5.35829 17.3072 5.33691 17.2746 5.32221 17.2386C5.3075 17.2027 5.29975 17.164 5.29939 17.1249V7.77611H4.14555C4.09151 7.77637 4.03849 7.76081 3.99252 7.73121C3.94655 7.70161 3.90947 7.65916 3.88551 7.60868C3.86199 7.55873 3.85282 7.50277 3.8591 7.44752C3.86538 7.39227 3.88684 7.34008 3.92091 7.29724L6.52539 3.33438C6.55283 3.30013 6.5872 3.27263 6.62604 3.25387C6.66488 3.2351 6.70722 3.22553 6.75003 3.22584C6.83717 3.22584 6.92022 3.26557 6.97468 3.33509L8.27692 5.31652L9.57916 7.29795C9.61322 7.34079 9.63469 7.39298 9.64097 7.44823C9.64725 7.50348 9.63808 7.55944 9.61456 7.60939C9.5906 7.65987 9.55352 7.70232 9.50755 7.73192C9.46158 7.76152 9.40856 7.77708 9.35452 7.77682L9.3552 7.77611Z"
                    fill="#3326AE" />
                  <path
                    d="M13.4579 16.2903H11.9806L16.2534 4.65392H17.7079L21.9806 16.2903H20.5034L17.0261 6.49483H16.9352L13.4579 16.2903ZM14.0034 11.7448H19.9579V12.9948H14.0034V11.7448ZM28.6113 9.8471V11.0971H23.5204V9.8471H28.6113ZM30.7661 16.2903V15.2676L37.0389 5.90392H30.698V4.65392H38.7207V5.67665L32.448 15.0403H38.7889V16.2903H30.7661Z"
                    fill="#3326AE" />
                </svg>
              </div>
              <div class="open-folder-line-sort" @click="reverseSmjer(1)" id="date-filter">
                {{ $t("page_2.page_2_3.f2") }} {{ $t('components.general.file_management.tree_viewer.order_by_text') }}
                <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"
                  class="svg-to-rotate">
                  <g clip-path="url(#clip0_1212_3564)">
                    <path
                      d="M10.2379 8.31799H4.57294C4.43494 8.31799 4.32294 8.20899 4.32294 8.07399V5.15899C4.3232 5.12647 4.32988 5.09432 4.3426 5.06438C4.35531 5.03445 4.37382 5.00732 4.39705 4.98456C4.42027 4.9618 4.44777 4.94384 4.47795 4.93173C4.50814 4.91962 4.54041 4.91359 4.57294 4.91399H10.2379C10.2705 4.91359 10.3027 4.91962 10.3329 4.93173C10.3631 4.94384 10.3906 4.9618 10.4138 4.98456C10.4371 5.00732 10.4556 5.03445 10.4683 5.06438C10.481 5.09432 10.4877 5.12647 10.4879 5.15899V8.07399C10.4879 8.20899 10.3759 8.31799 10.2379 8.31799ZM10.2379 3.42299H7.03693C6.89893 3.42299 6.78693 3.31299 6.78693 3.17799V0.262991C6.7872 0.230469 6.79388 0.198318 6.80659 0.168385C6.81931 0.138451 6.83782 0.111326 6.86104 0.088562C6.88427 0.0657983 6.91177 0.0478466 6.94195 0.0357361C6.97214 0.0236256 7.00441 0.0175941 7.03693 0.0179901H10.2369C10.2695 0.0175941 10.3017 0.0236256 10.3319 0.0357361C10.3621 0.0478466 10.3896 0.0657983 10.4128 0.088562C10.4361 0.111326 10.4546 0.138451 10.4673 0.168385C10.48 0.198318 10.4867 0.230469 10.4869 0.262991V3.17799C10.4869 3.31299 10.3769 3.42299 10.2379 3.42299ZM10.2379 14.147L2.40993 14.147C2.27194 14.147 2.15993 14.037 2.15993 13.902V10.988C2.16073 10.9224 2.18748 10.8598 2.23433 10.8139C2.28119 10.7679 2.34433 10.7425 2.40993 10.743H10.2379C10.3035 10.7425 10.3667 10.7679 10.4135 10.8139C10.4604 10.8598 10.4871 10.9224 10.4879 10.988L10.4879 13.902C10.4879 14.037 10.3759 14.147 10.2379 14.147ZM0.247934 16.572L10.2379 16.572C10.2705 16.5716 10.3027 16.5776 10.3329 16.5897C10.3631 16.6018 10.3906 16.6198 10.4138 16.6426C10.4371 16.6653 10.4556 16.6925 10.4683 16.7224C10.481 16.7523 10.4877 16.7845 10.4879 16.817V19.731C10.4879 19.866 10.3759 19.976 10.2379 19.976L0.246935 19.976C0.108935 19.976 -0.00306511 19.866 -0.00306511 19.731V16.817C-0.00280418 16.7845 0.0038762 16.7523 0.0165939 16.7224C0.0293117 16.6925 0.0478167 16.6653 0.0710449 16.6426C0.0942732 16.6198 0.121769 16.6018 0.151953 16.5897C0.182137 16.5776 0.215414 16.5716 0.247934 16.572ZM11.9209 13.586H13.6179L13.6179 0.407991C13.6193 0.296948 13.6645 0.190945 13.7438 0.113173C13.823 0.0354005 13.9299 -0.00781057 14.0409 -0.00700951H17.4549C17.51 -0.00766964 17.5647 0.00254873 17.6159 0.0230598C17.667 0.043571 17.7137 0.0739722 17.753 0.112522C17.7924 0.151072 17.8238 0.197014 17.8454 0.247715C17.867 0.298416 17.8784 0.352882 17.8789 0.407991L17.8789 13.586H19.5739C19.6533 13.5856 19.7312 13.6075 19.7987 13.6493C19.8663 13.691 19.9207 13.7508 19.9559 13.822C19.9905 13.8924 20.004 13.9713 19.9947 14.0492C19.9855 14.127 19.954 14.2006 19.9039 14.261L16.0779 19.847C16.0376 19.8953 15.9871 19.934 15.9301 19.9605C15.873 19.9869 15.8108 20.0004 15.7479 20C15.6199 20 15.4979 19.944 15.4179 19.846L11.5919 14.26C11.5419 14.1996 11.5104 14.126 11.5011 14.0482C11.4919 13.9703 11.5054 13.8914 11.5399 13.821C11.5751 13.7498 11.6296 13.69 11.6971 13.6483C11.7647 13.6065 11.8426 13.5846 11.9219 13.585L11.9209 13.586Z"
                      fill="#3326AE" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1212_3564">
                      <rect width="20" height="20" fill="white" transform="translate(20 20) rotate(-180)" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </div>
          </div>
          <div id="tree-menu" style="overflow: hidden"
            v-if="is_permission_inside('read', false) && all_files_rec != null">
            <tree-menu :depth="0" :item="filtered_files" :is_editable="permission.create" :accessToken="accessToken"
              @node-click="logClick" @multi-select="setMultiFileSelection" @show-children="folderStatusChange"
              @folder-create="handleFolderCreateFromFile" @folder-add="handleFolderCreateFromFolder"
              @share-file="staggedEmitShare" :smjer="smjer" @node-drag="nodeDrag" @folder-hover="folderHover"
              @file-move="moveFile" :tagged_files="tagged_files"></tree-menu>
            <div v-if="
              all_files_rec.children.length == 0 &&
              permission.create &&
              are_files_loaded
            " class="new-spis-wrapper">
              <div class="new-spis-element" @click="openUploadFolder">
                <svg xmlns="http://www.w3.org/2000/svg" width="34" height="32" viewBox="0 0 42 32" fill="none">
                  <path
                    d="M33.2862 4.19414C33.3968 4.30546 33.4589 4.45603 33.4589 4.61297C33.4589 4.76991 33.3968 4.92048 33.2862 5.0318L21.2661 17.1247C20.8977 17.4965 20.4592 17.7915 19.976 17.9926C19.4928 18.1937 18.9744 18.2969 18.451 18.2962C17.9277 18.2968 17.4094 18.1936 16.9261 17.9925C16.4429 17.7914 16.0044 17.4964 15.636 17.1247L3.61674 5.03264C3.50585 4.92128 3.44359 4.77054 3.44359 4.61339C3.44359 4.45624 3.50585 4.30549 3.61674 4.19414C3.67122 4.13899 3.73611 4.09519 3.80765 4.06531C3.87919 4.03542 3.95594 4.02003 4.03347 4.02003C4.111 4.02003 4.18776 4.03542 4.2593 4.06531C4.33083 4.09519 4.39572 4.13899 4.45021 4.19414L16.4695 16.2862C16.7292 16.5474 17.038 16.7547 17.3782 16.8962C17.7183 17.0377 18.0831 17.1105 18.4515 17.1105C18.8199 17.1105 19.1846 17.0377 19.5248 16.8962C19.8649 16.7547 20.1737 16.5474 20.4335 16.2862L32.4536 4.19498C32.508 4.13995 32.5729 4.09626 32.6443 4.06645C32.7158 4.03664 32.7924 4.02129 32.8699 4.02129C32.9473 4.02129 33.024 4.03664 33.0954 4.06645C33.1669 4.09626 33.2317 4.13995 33.2862 4.19498V4.19414ZM1.17824 4.38996V22.9715C1.17824 24.7381 2.60753 26.1766 4.36402 26.1766H28.9029V27.3623H4.36402C1.95816 27.3623 0 25.3925 0 22.9715V4.38996C0 1.96904 1.95816 0 4.36402 0H32.5397C34.9456 0 36.9029 1.96987 36.9029 4.39079V19.2536H35.7255V4.39079C35.7255 2.62259 34.2962 1.18577 32.5397 1.18577H4.36402C2.60669 1.18577 1.17824 2.62343 1.17824 4.39079V4.38996ZM30.8268 26.6385C30.8268 26.2745 31.1197 25.9799 31.482 25.9799H35.5029V21.9347C35.5029 21.5715 35.7966 21.277 36.1582 21.277C36.5197 21.277 36.8126 21.5715 36.8126 21.9347V25.9799H40.8343C41.1958 25.9799 41.4887 26.2745 41.4887 26.6385C41.4887 27.0017 41.1958 27.2962 40.8343 27.2962H36.8134V31.3414C36.8134 31.7054 36.5205 32 36.159 32C36.0727 31.9998 35.9874 31.9826 35.9077 31.9494C35.8281 31.9161 35.7558 31.8676 35.695 31.8064C35.6341 31.7453 35.5859 31.6727 35.5531 31.5929C35.5203 31.5132 35.5035 31.4277 35.5038 31.3414V27.2971H31.4828C31.3088 27.2966 31.142 27.2271 31.0191 27.1038C30.8963 26.9805 30.8274 26.8134 30.8276 26.6393L30.8268 26.6385Z"
                    fill="#B8B8C1" />
                </svg>
                <span>{{ $t("page_2.page_2_3.empty_msg") }}</span>
              </div>
            </div>
            <!-- <div v-if="!are_files_loaded" class="new-spis-wrapper">
                    <div class="new-spis-element" @click="uploadStyling">
                      <div class="elastic-wrapp">
                        <div class="dot-elastic"></div>
                      </div>
                    </div>
                  </div> -->
          </div>
        </div>
      </div>
      <div class="spisi-right" v-if="right_activity_file == 1">
        <div class="detalji-spisa section">
          <div class="section-title">
            {{ $t("page_2.page_2_3.detail_3.title") }}
            <div class="edit-detalji-spisa add-button add-pen" v-if="is_permission_inside('create')"
              @click="openFolderRenamePop()">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                <g>
                  <g>
                    <path fill="#7b7b8a"
                      d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z" />
                  </g>
                </g>
              </svg>
            </div>

            <a @click="closeDetalji()" class="entry-exit"><img src="@/assets/img/entry_form_close.svg" /></a>
          </div>
          <div class="detalji-spisa-top">
            <img class="doc-icon" src="@/assets/img/folder_icon.svg" />
            <div class="inside-folder-txts">
              <div class="inside-folder-title">
                {{ getFolderName(activityFile.name) }}
              </div>
              <div class="detalji-spisa-tiny">
                <span class="tezina">{{ (activityFile.size * 0.000001).toFixed(4) }}MB</span>
              </div>
            </div>
          </div>
          <div class="detalji-spisa-list">
            <div class="detalji-spisa-middle">
              <div class="case-info-item">
                <div class="case-info-item-title">
                  {{ $t("page_2.page_2_3.detail_3.tl_1") }}
                </div>
                <div class="case-info-item-info">
                  {{ switchDate(activityFile.createdDateTime) }}
                </div>
              </div>
              <div class="case-info-item">
                <div class="case-info-item-title">
                  {{ $t("page_2.page_2_3.detail_3.tl_2") }}:
                </div>
                <div class="case-info-item-info">
                  <a href="#">{{ activityFile.createdBy.user.displayName }}</a>
                </div>
              </div>
              <div class="case-info-item">
                <div class="case-info-item-title">
                  {{ $t("page_2.page_2_3.detail_3.tl_3") }}:
                </div>
                <div class="case-info-item-info">
                  <a href="#">{{ activityFile.lastModifiedBy.user.displayName }} ({{
                    switchDate(activityFile.lastModifiedDateTime)
                  }})</a>
                </div>
              </div>
            </div>
          </div>
          <div class="detalji-buttons detalji-buttons-tri" v-if="is_permission_inside('read')">
            <div class="delete-button icon-button" v-if="
              is_permission_inside('delete', false) &&
              activityFile.id != folder_id &&
              activityFile.folder.childCount == 0
            " @click="delete_screen = true">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18">
                <g>
                  <g>
                    <path fill="#2b2b41"
                      d="M12.8 5.63v9.455C12.8 16.692 11.5 18 9.904 18H3.52C1.925 18 .626 16.692.626 15.085V5.63c0-.334.27-.605.601-.605h10.971c.332 0 .601.27.601.605zM5.267 8.67c0-.41-.33-.743-.739-.743a.741.741 0 0 0-.738.743v5.685c0 .41.33.743.738.743a.741.741 0 0 0 .739-.743zm4.367 0c0-.41-.33-.743-.739-.743a.741.741 0 0 0-.738.743v5.685c0 .41.33.743.738.743a.741.741 0 0 0 .739-.743zm3.78-5.896V3.95c0 .21-.17.38-.378.38H.389a.379.379 0 0 1-.378-.38V2.774c0-1.01.816-1.83 1.819-1.83h2.618v-.23c0-.393.318-.712.708-.712H8.27c.391 0 .709.32.709.713v.228h2.618c1.003 0 1.819.822 1.819 1.831z" />
                  </g>
                </g>
              </svg>
              {{ $t("page_2.page_2_3.detail_3.btn_1") }}
            </div>
          </div>
        </div>
      </div>
      <div class="spisi-right" v-if="right_activity_file == 3">
        <div class="detalji-spisa section">
          <div class="section-title">
            {{ $t("page_2.page_2_3.detail_4.title") }}
            <a @click="closeDetalji()" class="entry-exit"><img src="@/assets/img/entry_form_close.svg" /></a>
          </div>
          <div class="scroll-select-docs">
            <div class="detalji-spisa-top" v-for="(singleFile, key) in multi_file_list" :key="key">
              <img class="doc-icon" :src="returnFileType(singleFile.name)" />
              <div class="inside-folder-txts">
                <div class="inside-folder-title">{{ singleFile.name }}</div>
                <div class="detalji-spisa-tiny">
                  <span class="tezina">{{ (singleFile.size * 0.000001).toFixed(4) }}MB</span>
                </div>
              </div>
            </div>
          </div>

          <div class="detalji-buttons detalji-buttons-tri" v-if="is_permission_inside('read')">
            <div class="radni-button icon-button" v-if="is_permission_inside('move') && movable"
              @click="preseliStyling()">
              {{ $t("page_2.page_2_4.detail_2.btn_1") }}
              <svg class="preseli-icon" xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 13 10"
                fill="none">
                <path
                  d="M7.71967 1.28033C7.42678 0.987437 7.42678 0.512563 7.71967 0.21967C8.01256 -0.0732233 8.48744 -0.0732233 8.78033 0.21967L12.7803 4.21967C13.0732 4.51256 13.0732 4.98744 12.7803 5.28033L8.78033 9.28033C8.48744 9.57322 8.01256 9.57322 7.71967 9.28033C7.42678 8.98744 7.42678 8.51256 7.71967 8.21967L10.4393 5.5H0.75C0.335787 5.5 0 5.16421 0 4.75C0 4.33579 0.335787 4 0.75 4H10.4393L7.71967 1.28033Z"
                  fill="#75747F" />
              </svg>
            </div>

            <!-- <div
              class="radni-button icon-button"
              v-if="
                is_permission_inside('read') &&
                can_share
              "
              @click="emitShareDoc(activityFile.id)"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.3333 11.3092C12.6578 11.3092 12.0533 11.5502 11.5911 11.9277L5.25333 8.59438C5.29778 8.40964 5.33333 8.2249 5.33333 8.03213C5.33333 7.83936 5.29778 7.65462 5.25333 7.46988L11.52 4.16867C12 4.57028 12.6311 4.81928 13.3333 4.81928C14.8089 4.81928 16 3.74297 16 2.40964C16 1.07631 14.8089 0 13.3333 0C11.8578 0 10.6667 1.07631 10.6667 2.40964C10.6667 2.60241 10.7022 2.78715 10.7467 2.97189L4.48 6.27309C4 5.87149 3.36889 5.62249 2.66667 5.62249C1.19111 5.62249 0 6.69879 0 8.03213C0 9.36546 1.19111 10.4418 2.66667 10.4418C3.36889 10.4418 4 10.1928 4.48 9.79116L10.8089 13.1325C10.7644 13.3012 10.7378 13.4779 10.7378 13.6546C10.7378 14.9478 11.9022 16 13.3333 16C14.7644 16 15.9289 14.9478 15.9289 13.6546C15.9289 12.3614 14.7644 11.3092 13.3333 11.3092Z"
                  fill="#70707F"
                />
              </svg>
            </div> -->

            <div class="radni-button icon-button" @click="openSelectedFiles()">
              {{ $t("page_2.page_2_4.detail_2.btn_2") }}
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M6.61764 8.31605C6.61764 6.06224 8.44471 4.23516 10.6985 4.23516C12.9523 4.23516 14.7794 6.06224 14.7794 8.31605C14.7794 10.5699 12.9523 12.3969 10.6985 12.3969C8.44471 12.3969 6.61764 10.5699 6.61764 8.31605ZM10.6985 5.86752C9.34623 5.86752 8.24999 6.96376 8.24999 8.31605C8.24999 9.66833 9.34623 10.7646 10.6985 10.7646C12.0508 10.7646 13.147 9.66833 13.147 8.31605C13.147 6.96376 12.0508 5.86752 10.6985 5.86752Z"
                  fill="#70707F" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M2.3446 6.84296C1.8885 7.50018 1.72058 8.01428 1.72058 8.31605C1.72058 8.61782 1.8885 9.13191 2.3446 9.78913C2.78549 10.4244 3.44083 11.1131 4.26996 11.7495C5.93181 13.0249 8.21022 14.0293 10.6985 14.0293C13.1868 14.0293 15.4652 13.0249 17.1271 11.7495C17.9562 11.1131 18.6115 10.4244 19.0524 9.78913C19.5085 9.13191 19.6765 8.61782 19.6765 8.31605C19.6765 8.01428 19.5085 7.50018 19.0524 6.84296C18.6115 6.20765 17.9562 5.51898 17.1271 4.88263C15.4652 3.60717 13.1868 2.60281 10.6985 2.60281C8.21022 2.60281 5.93181 3.60717 4.26996 4.88263C3.44083 5.51898 2.78549 6.20765 2.3446 6.84296ZM3.27611 3.5877C5.15903 2.14257 7.77768 0.970459 10.6985 0.970459C13.6194 0.970459 16.238 2.14257 18.1209 3.5877C19.0642 4.31165 19.8432 5.1193 20.3935 5.91229C20.9286 6.68338 21.3088 7.52958 21.3088 8.31605C21.3088 9.10251 20.9286 9.94871 20.3935 10.7198C19.8432 11.5128 19.0642 12.3204 18.1209 13.0444C16.238 14.4895 13.6194 15.6616 10.6985 15.6616C7.77768 15.6616 5.15903 14.4895 3.27611 13.0444C2.33285 12.3204 1.55387 11.5128 1.00354 10.7198C0.468424 9.94871 0.0882263 9.10251 0.0882263 8.31605C0.0882263 7.52958 0.468424 6.68338 1.00354 5.91229C1.55387 5.1193 2.33285 4.31165 3.27611 3.5877Z"
                  fill="#70707F" />
              </svg>
            </div>
            <div>
              <email-response :file_list="multi_file_list" />
            </div>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on" class="detalji-buttons-obrisi">
                  <div class="delete-button icon-button duplicate-button" v-if="is_permission_inside('read')"
                    @click="downloadSelectedFiles()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 16 20" fill="none">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M6.6975 0C5.89894 0 5.23277 0.648667 5.16304 1.49419C5.01724 3.26199 4.98035 5.03769 5.05247 6.80992C4.96541 6.81611 4.87837 6.82256 4.79135 6.82928L3.25379 6.94843C2.27103 7.02459 1.72166 8.18923 2.25222 9.07179C3.38376 10.9539 4.84177 12.5902 6.54854 13.8933L7.16454 14.3636C7.66395 14.745 8.33665 14.745 8.83606 14.3636L9.45206 13.8933C11.1588 12.5902 12.6169 10.9539 13.7484 9.07179C14.2789 8.18923 13.7296 7.02459 12.7468 6.94843L11.2093 6.82928C11.1222 6.82256 11.0352 6.81611 10.9481 6.80992C11.0203 5.03768 10.9834 3.26199 10.8376 1.49418C10.7678 0.648661 10.1017 0 9.3031 0H6.6975Z"
                        fill="black" />
                      <path
                        d="M1.54839 15.0855C1.54839 14.6311 1.20177 14.2627 0.774192 14.2627C0.346618 14.2627 0 14.6311 0 15.0855V17.2798C0 18.3402 0.808779 19.1998 1.80645 19.1998H14.1935C15.1912 19.1998 16 18.3402 16 17.2798V15.0855C16 14.6311 15.6534 14.2627 15.2258 14.2627C14.7982 14.2627 14.4516 14.6311 14.4516 15.0855V17.2798C14.4516 17.4313 14.3361 17.5541 14.1935 17.5541H1.80645C1.66393 17.5541 1.54839 17.4313 1.54839 17.2798V15.0855Z"
                        fill="black" />
                    </svg>
                  </div>
                </div>
              </template>
              <div>{{ $t("racunovodstvo_nalozi.download") }}</div>
            </v-tooltip>
            <FileMove v-if="multi_file_list && visible_copy_to_other_cases" :files_for_copy="multi_file_list" />

            <div>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on" class="detalji-buttons-obrisi">
                    <div class="delete-button icon-button duplicate-button"
                      v-if="is_permission_inside('read') && can_share" @click="emitShareDoc()">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M13.3333 11.3092C12.6578 11.3092 12.0533 11.5502 11.5911 11.9277L5.25333 8.59438C5.29778 8.40964 5.33333 8.2249 5.33333 8.03213C5.33333 7.83936 5.29778 7.65462 5.25333 7.46988L11.52 4.16867C12 4.57028 12.6311 4.81928 13.3333 4.81928C14.8089 4.81928 16 3.74297 16 2.40964C16 1.07631 14.8089 0 13.3333 0C11.8578 0 10.6667 1.07631 10.6667 2.40964C10.6667 2.60241 10.7022 2.78715 10.7467 2.97189L4.48 6.27309C4 5.87149 3.36889 5.62249 2.66667 5.62249C1.19111 5.62249 0 6.69879 0 8.03213C0 9.36546 1.19111 10.4418 2.66667 10.4418C3.36889 10.4418 4 10.1928 4.48 9.79116L10.8089 13.1325C10.7644 13.3012 10.7378 13.4779 10.7378 13.6546C10.7378 14.9478 11.9022 16 13.3333 16C14.7644 16 15.9289 14.9478 15.9289 13.6546C15.9289 12.3614 14.7644 11.3092 13.3333 11.3092Z"
                          fill="#70707F" />
                      </svg>
                    </div>
                  </div>
                </template>
                <div>Dijeljenje</div>
              </v-tooltip>
            </div>
          </div>
        </div>
      </div>
      <div class="spisi-right" v-if="right_activity_file == 2">
        <div class="detalji-spisa section">
          <div class="section-title">
            {{ $t("page_2.page_2_3.detail_2.title") }}
            <div class="edit-detalji-spisa add-button add-pen" v-if="is_permission_inside('create')"
              @click="openRenamePop()">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                <g>
                  <g>
                    <path fill="#7b7b8a"
                      d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z" />
                  </g>
                </g>
              </svg>
            </div>
            <div class="edit-detalji-spisa add-button add-pen" v-if="is_permission_inside('read')"
              @click="downloadSingleFile()">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 16 20" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M6.6975 0C5.89894 0 5.23277 0.648667 5.16304 1.49419C5.01724 3.26199 4.98035 5.03769 5.05247 6.80992C4.96541 6.81611 4.87837 6.82256 4.79135 6.82928L3.25379 6.94843C2.27103 7.02459 1.72166 8.18923 2.25222 9.07179C3.38376 10.9539 4.84177 12.5902 6.54854 13.8933L7.16454 14.3636C7.66395 14.745 8.33665 14.745 8.83606 14.3636L9.45206 13.8933C11.1588 12.5902 12.6169 10.9539 13.7484 9.07179C14.2789 8.18923 13.7296 7.02459 12.7468 6.94843L11.2093 6.82928C11.1222 6.82256 11.0352 6.81611 10.9481 6.80992C11.0203 5.03768 10.9834 3.26199 10.8376 1.49418C10.7678 0.648661 10.1017 0 9.3031 0H6.6975Z"
                  fill="black" />
                <path
                  d="M1.54839 15.0855C1.54839 14.6311 1.20177 14.2627 0.774192 14.2627C0.346618 14.2627 0 14.6311 0 15.0855V17.2798C0 18.3402 0.808779 19.1998 1.80645 19.1998H14.1935C15.1912 19.1998 16 18.3402 16 17.2798V15.0855C16 14.6311 15.6534 14.2627 15.2258 14.2627C14.7982 14.2627 14.4516 14.6311 14.4516 15.0855V17.2798C14.4516 17.4313 14.3361 17.5541 14.1935 17.5541H1.80645C1.66393 17.5541 1.54839 17.4313 1.54839 17.2798V15.0855Z"
                  fill="black" />
              </svg>
            </div>
            <a @click="closeDetalji()" class="entry-exit"><img src="@/assets/img/entry_form_close.svg" /></a>
          </div>
          <div class="detalji-spisa-top">
            <img class="doc-icon" :src="returnFileType(activityFile.name)" />
            <div class="inside-folder-txts">
              <div class="inside-folder-title">{{ activityFile.name }}</div>
              <div class="detalji-spisa-tiny">
                <span class="tezina">{{ (activityFile.size * 0.000001).toFixed(4) }}MB</span>
              </div>
            </div>
          </div>
          <div class="detalji-spisa-list">
            <div class="detalji-spisa-middle">
              <div class="case-info-item">
                <div class="case-info-item-title">
                  {{ $t("page_2.page_2_3.detail_2.tl_1") }}
                </div>
                <div class="case-info-item-info">
                  {{ switchDate(activityFile.createdDateTime) }}
                </div>
              </div>
              <div class="case-info-item">
                <div class="case-info-item-title">
                  {{ $t("page_2.page_2_3.detail_2.tl_2") }}:
                </div>
                <div class="case-info-item-info">
                  <a href="#">{{ activityFile.createdBy.user.displayName }}</a>
                </div>
              </div>
              <div class="case-info-item" v-if="getUsersSharedWith(activityFile.id) != ''">
                <div class="case-info-item-title">Dijeljeno:</div>
                <div class="case-info-item-info">
                  <a href="#">{{ getUsersSharedWith(activityFile.id) }}</a>
                </div>
              </div>
              <div class="case-info-item" v-if="getUsersSharedWith(activityFile.id) != ''">
                <div class="case-info-item-title">Datum dijeljenja:</div>
                <div class="case-info-item-info">
                  <a href="#">{{ getSharedFileShareDate(activityFile.id) }}</a>
                </div>
              </div>
              <div class="case-info-item" v-if="getUsersSharedWith(activityFile.id) != ''">
                <div class="case-info-item-title">Aktivnost dijeljenja:</div>
                <div class="case-info-item-info">
                  <a href="#">{{
                    getRemainderOfActiveYears(activityFile.id)
                    }}</a>
                </div>
              </div>

              <div class="case-info-item">
                <div class="case-info-item-title">
                  {{ $t("page_2.page_2_3.detail_2.tl_3") }}:
                </div>
                <div class="case-info-item-info">
                  <a href="#">{{ activityFile.lastModifiedBy.user.displayName }} ({{
                    switchDate(activityFile.lastModifiedDateTime)
                  }})</a>
                </div>
              </div>
            </div>
            <!-- <div class="case-info-item">
                    <div class="case-info-item-title">Tagovi</div>
                    <div class="case-info-item-info">
                      <span class="tag">#spis</span>
                      <span class="tag">#legroulx</span
                      ><span class="tag">#radni</span
                      ><span class="tag">#tablica</span>
                    </div>
                  </div> -->
          </div>
          <div class="detalji-buttons detalji-buttons-tri">
            <div class="radni-button icon-button" v-if="
              is_permission_inside('move') &&
              activityFile.folder == undefined &&
              movable
            " @click="preseliStyling()">
              {{ $t("page_2.page_2_4.detail_2.btn_1") }}
              <svg class="preseli-icon" xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 13 10"
                fill="none">
                <path
                  d="M7.71967 1.28033C7.42678 0.987437 7.42678 0.512563 7.71967 0.21967C8.01256 -0.0732233 8.48744 -0.0732233 8.78033 0.21967L12.7803 4.21967C13.0732 4.51256 13.0732 4.98744 12.7803 5.28033L8.78033 9.28033C8.48744 9.57322 8.01256 9.57322 7.71967 9.28033C7.42678 8.98744 7.42678 8.51256 7.71967 8.21967L10.4393 5.5H0.75C0.335787 5.5 0 5.16421 0 4.75C0 4.33579 0.335787 4 0.75 4H10.4393L7.71967 1.28033Z"
                  fill="#75747F" />
              </svg>
            </div>
            <div class="radni-button icon-button" v-if="
              is_permission_inside('read') && activityFile.folder == undefined
            " @click="openFile(activityFile.webUrl)">
              {{ $t("page_2.page_2_4.detail_2.btn_2") }}
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M6.61764 8.31605C6.61764 6.06224 8.44471 4.23516 10.6985 4.23516C12.9523 4.23516 14.7794 6.06224 14.7794 8.31605C14.7794 10.5699 12.9523 12.3969 10.6985 12.3969C8.44471 12.3969 6.61764 10.5699 6.61764 8.31605ZM10.6985 5.86752C9.34623 5.86752 8.24999 6.96376 8.24999 8.31605C8.24999 9.66833 9.34623 10.7646 10.6985 10.7646C12.0508 10.7646 13.147 9.66833 13.147 8.31605C13.147 6.96376 12.0508 5.86752 10.6985 5.86752Z"
                  fill="#70707F" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M2.3446 6.84296C1.8885 7.50018 1.72058 8.01428 1.72058 8.31605C1.72058 8.61782 1.8885 9.13191 2.3446 9.78913C2.78549 10.4244 3.44083 11.1131 4.26996 11.7495C5.93181 13.0249 8.21022 14.0293 10.6985 14.0293C13.1868 14.0293 15.4652 13.0249 17.1271 11.7495C17.9562 11.1131 18.6115 10.4244 19.0524 9.78913C19.5085 9.13191 19.6765 8.61782 19.6765 8.31605C19.6765 8.01428 19.5085 7.50018 19.0524 6.84296C18.6115 6.20765 17.9562 5.51898 17.1271 4.88263C15.4652 3.60717 13.1868 2.60281 10.6985 2.60281C8.21022 2.60281 5.93181 3.60717 4.26996 4.88263C3.44083 5.51898 2.78549 6.20765 2.3446 6.84296ZM3.27611 3.5877C5.15903 2.14257 7.77768 0.970459 10.6985 0.970459C13.6194 0.970459 16.238 2.14257 18.1209 3.5877C19.0642 4.31165 19.8432 5.1193 20.3935 5.91229C20.9286 6.68338 21.3088 7.52958 21.3088 8.31605C21.3088 9.10251 20.9286 9.94871 20.3935 10.7198C19.8432 11.5128 19.0642 12.3204 18.1209 13.0444C16.238 14.4895 13.6194 15.6616 10.6985 15.6616C7.77768 15.6616 5.15903 14.4895 3.27611 13.0444C2.33285 12.3204 1.55387 11.5128 1.00354 10.7198C0.468424 9.94871 0.0882263 9.10251 0.0882263 8.31605C0.0882263 7.52958 0.468424 6.68338 1.00354 5.91229C1.55387 5.1193 2.33285 4.31165 3.27611 3.5877Z"
                  fill="#70707F" />
              </svg>
            </div>
            <div class="radni-button icon-button" v-if="
              is_permission_inside('read') &&
              activityFile.folder == undefined &&
              can_share
            " @click="emitShareDoc(activityFile.id)">
              Dijeljenje
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M13.3333 11.3092C12.6578 11.3092 12.0533 11.5502 11.5911 11.9277L5.25333 8.59438C5.29778 8.40964 5.33333 8.2249 5.33333 8.03213C5.33333 7.83936 5.29778 7.65462 5.25333 7.46988L11.52 4.16867C12 4.57028 12.6311 4.81928 13.3333 4.81928C14.8089 4.81928 16 3.74297 16 2.40964C16 1.07631 14.8089 0 13.3333 0C11.8578 0 10.6667 1.07631 10.6667 2.40964C10.6667 2.60241 10.7022 2.78715 10.7467 2.97189L4.48 6.27309C4 5.87149 3.36889 5.62249 2.66667 5.62249C1.19111 5.62249 0 6.69879 0 8.03213C0 9.36546 1.19111 10.4418 2.66667 10.4418C3.36889 10.4418 4 10.1928 4.48 9.79116L10.8089 13.1325C10.7644 13.3012 10.7378 13.4779 10.7378 13.6546C10.7378 14.9478 11.9022 16 13.3333 16C14.7644 16 15.9289 14.9478 15.9289 13.6546C15.9289 12.3614 14.7644 11.3092 13.3333 11.3092Z"
                  fill="#70707F" />
              </svg>
            </div>
            <v-tooltip top v-if="duplicatable">
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on" class="detalji-buttons-obrisi">
                  <div class="delete-button icon-button duplicate-button" v-if="
                    activityFile != null && activityFile.folder == undefined
                  " @click="copyFile">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                      <path
                        d="M5.75 0C2.57436 0 0 2.57436 0 5.75V12.8569C0 13.2711 0.335786 13.6069 0.75 13.6069C1.16421 13.6069 1.5 13.2711 1.5 12.8569V5.75C1.5 3.40279 3.40279 1.5 5.75 1.5H12.7629C13.1771 1.5 13.5129 1.16421 13.5129 0.75C13.5129 0.335786 13.1771 0 12.7629 0H5.75Z"
                        fill="#70707F" />
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M15.1526 3.54326C11.9116 3.18104 8.58843 3.18104 5.34748 3.54326C4.4242 3.64645 3.68227 4.37304 3.57344 5.30348C3.18906 8.58996 3.18906 11.91 3.57344 15.1965C3.68227 16.127 4.4242 16.8535 5.34748 16.9567C8.58843 17.319 11.9116 17.319 15.1526 16.9567C16.0758 16.8535 16.8178 16.127 16.9266 15.1965C17.311 11.91 17.311 8.58996 16.9266 5.30348C16.8178 4.37304 16.0758 3.64645 15.1526 3.54326ZM5.51409 5.03398C8.64431 4.68413 11.8557 4.68413 14.9859 5.03398C15.2233 5.0605 15.4099 5.24821 15.4367 5.47773C15.8076 8.64843 15.8076 11.8516 15.4367 15.0223C15.4099 15.2518 15.2233 15.4395 14.9859 15.466C11.8557 15.8159 8.64431 15.8159 5.51409 15.466C5.27674 15.4395 5.09013 15.2518 5.06329 15.0223C4.69245 11.8516 4.69245 8.64844 5.06329 5.47773C5.09013 5.24821 5.27674 5.0605 5.51409 5.03398Z"
                        fill="#70707F" />
                    </svg>
                  </div>
                </div>
              </template>
              <div>
                {{ $t("page_2.page_2_4.detail_2.btn_3") }}
              </div>
            </v-tooltip>

            <FileMove v-if="multi_file_list && visible_copy_to_other_cases" :files_for_copy="multi_file_list" />

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on" class="detalji-buttons-obrisi">
                  <div class="delete-button icon-button" v-if="
                    is_permission_inside('delete', false) &&
                    activityFile != null &&
                    activityFile.folder == undefined
                  " @click="delete_screen = true">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="21" viewBox="0 0 16 21" fill="none">
                      <path
                        d="M5.75 0C5.33579 0 5 0.335786 5 0.75V1.5H0.75C0.335786 1.5 0 1.83579 0 2.25C0 2.66421 0.335786 3 0.75 3H14.75C15.1642 3 15.5 2.66421 15.5 2.25C15.5 1.83579 15.1642 1.5 14.75 1.5H10.5V0.75C10.5 0.335786 10.1642 0 9.75 0H5.75Z"
                        fill="#70707F" />
                      <path
                        d="M5.75 8.39999C6.16421 8.39999 6.5 8.73578 6.5 9.14999L6.5 16.15C6.5 16.5642 6.16421 16.9 5.75 16.9C5.33579 16.9 5 16.5642 5 16.15L5 9.14999C5 8.73578 5.33579 8.39999 5.75 8.39999Z"
                        fill="#70707F" />
                      <path
                        d="M10.5 9.14999C10.5 8.73578 10.1642 8.39999 9.75 8.39999C9.33579 8.39999 9 8.73578 9 9.14999V16.15C9 16.5642 9.33579 16.9 9.75 16.9C10.1642 16.9 10.5 16.5642 10.5 16.15V9.14999Z"
                        fill="#70707F" />
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M1.74142 5.66718C1.78363 5.28735 2.10468 5 2.48684 5H13.0132C13.3953 5 13.7164 5.28735 13.7586 5.66718L13.9587 7.46852C14.3215 10.7338 14.3215 14.0293 13.9587 17.2946L13.939 17.472C13.795 18.7681 12.7904 19.8017 11.4989 19.9825C9.01176 20.3307 6.48823 20.3307 4.00108 19.9825C2.70954 19.8017 1.705 18.7681 1.56098 17.472L1.54128 17.2946C1.17846 14.0293 1.17846 10.7338 1.54128 7.46852L1.74142 5.66718ZM3.15812 6.5L3.0321 7.63417C2.68152 10.7894 2.68152 13.9738 3.0321 17.129L3.0518 17.3063C3.12011 17.921 3.59652 18.4112 4.20905 18.497C6.55822 18.8258 8.94177 18.8258 11.2909 18.497C11.9035 18.4112 12.3799 17.921 12.4482 17.3063L12.4679 17.129C12.8185 13.9738 12.8185 10.7894 12.4679 7.63417L12.3419 6.5H3.15812Z"
                        fill="#70707F" />
                    </svg>
                  </div>
                </div>
              </template>
              <div>
                {{ $t("page_2.page_2_4.detail_2.btn_4") }}
              </div>
            </v-tooltip>
            <div class="delete-button icon-button" v-if="
              is_permission_inside('delete', false) &&
              activityFile != null &&
              activityFile.id != folder_id &&
              activityFile.folder != undefined
            " @click="delete_screen = true">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18">
                <g>
                  <g>
                    <path fill="#2b2b41"
                      d="M12.8 5.63v9.455C12.8 16.692 11.5 18 9.904 18H3.52C1.925 18 .626 16.692.626 15.085V5.63c0-.334.27-.605.601-.605h10.971c.332 0 .601.27.601.605zM5.267 8.67c0-.41-.33-.743-.739-.743a.741.741 0 0 0-.738.743v5.685c0 .41.33.743.738.743a.741.741 0 0 0 .739-.743zm4.367 0c0-.41-.33-.743-.739-.743a.741.741 0 0 0-.738.743v5.685c0 .41.33.743.738.743a.741.741 0 0 0 .739-.743zm3.78-5.896V3.95c0 .21-.17.38-.378.38H.389a.379.379 0 0 1-.378-.38V2.774c0-1.01.816-1.83 1.819-1.83h2.618v-.23c0-.393.318-.712.708-.712H8.27c.391 0 .709.32.709.713v.228h2.618c1.003 0 1.819.822 1.819 1.831z" />
                  </g>
                </g>
              </svg>
              {{ $t("page_2.page_2_4.detail_2.btn_4") }}
            </div>
          </div>
        </div>
      </div>
      <div class="spisi-right" v-if="
        right_activity_file == 0 &&
        view_name == 'spisi' &&
        selected_spis != null
      ">
        <div class="detalji-spisa section">
          <div class="section-title">
            {{ $t("page_2.page_2_3.detail_1.title") }}
            <div v-if="is_permission_inside('edit')" class="edit-detalji-spisa add-button add-pen"
              @click="switchTab('spisi/' + selected_spis.id_spis + '/edit')">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                <g>
                  <g>
                    <path fill="#7b7b8a"
                      d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z" />
                  </g>
                </g>
              </svg>
            </div>
          </div>
          <!-- TODO dodati link na edit spisa -->
          <div class="detalji-spisa-top">
            <img class="doc-icon" src="@/assets/img/folder_icon.svg" />
            <div class="inside-folder-txts">
              <div class="inside-folder-title">
                {{ getFolderName(selected_spis.ime) }}
              </div>
              <div class="detalji-spisa-tiny">
                <span class="broj-dokumenata">{{ pdf_merge_file_list.length }}
                  {{ $t("page_2.page_2_3.detail_1.sub_1") }}</span><span class="tezina"
                  :key="pdf_merge_file_list.length">{{
                    (all_files_rec.item.size * 0.000001).toFixed(4)
                  }}
                  MB</span>
              </div>
            </div>
          </div>
          <div class="detalji-spisa-list">
            <div class="detalji-spisa-middle">
              <div class="case-info-item">
                <div class="case-info-item-title">
                  {{ $t("page_2.page_2_3.detail_1.tl_1") }}
                </div>
                <div class="case-info-item-info">
                  {{ switchDate(all_files_rec.item.createdDateTime) }}
                </div>
              </div>
              <div class="case-info-item">
                <div class="case-info-item-title">
                  {{ $t("page_2.page_2_3.detail_1.tl_2") }}:
                </div>
                <div class="case-info-item-info">
                  <a href="#">{{
                    all_files_rec.item.createdBy.user.displayName
                    }}</a>
                </div>
              </div>
            </div>
            <div class="detalji-spisa-end">
              <div class="case-info-item">
                <div class="case-info-item-title">
                  {{ $t("page_2.page_2_3.detail_1.tl_3") }}:
                </div>
                <div class="case-info-item-info">
                  {{ selected_spis.opis_spisa }}
                </div>
              </div>
              <div class="case-info-item">
                <div class="case-info-item-title">
                  {{ $t("page_2.page_2_3.detail_1.tl_4") }}
                </div>
                <div class="case-info-item-info">
                  <router-link v-if="selected_spis.institucija != null"
                    :to="'/osobe/institucije/' + selected_spis.institucija.uid">{{ selected_spis.institucija.naziv }}
                  </router-link>
                </div>
              </div>
              <!-- Vidjeti kak bi izlgedalo s stvarnim vrijednostima -->
              <div class="case-info-item">
                <div class="case-info-item-title">
                  {{ $t("page_2.page_2_3.detail_1.tl_5") }}:
                </div>
                <div class="case-info-item-info">
                  <div class="info-item-element" v-for="(
sudionik, key
                    ) in selected_spis.spis_sudionici_connector" :key="key">
                    <router-link :to="'/osobe/leg-body/' + sudionik.sluzbena_osoba.uid">{{ sudionik.sluzbena_osoba.ime
                      }}
                      {{ sudionik.sluzbena_osoba.prezime }}</router-link>
                  </div>
                </div>
              </div>
              <div class="case-info-item">
                <div class="case-info-item-title">
                  {{ $t("page_2.page_2_3.detail_1.tl_6") }}:
                </div>
                <div class="case-info-item-info">
                  {{ selected_spis.posl_br }}
                </div>
              </div>
              <div v-if="
                selected_spis.postupak.naziv != undefined &&
                selected_spis.postupak.naziv != null
              " class="case-info-item">
                <div class="case-info-item-title">
                  {{ $t("page_2.page_2_3.detail_1.tl_7") }}:
                </div>
                <div class="case-info-item-info">
                  {{ selected_spis.postupak.naziv }}
                </div>
              </div>
            </div>
          </div>
          <div class="detalji-buttons" v-if="is_permission_inside('read') && are_files_loaded">
            <div class="print-button icon-button" @click="spisToPDF()">
              <svg v-if="!pdf_mergeing" xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18">
                <g>
                  <g>
                    <path fill="#2b2b41"
                      d="M16.206 3.132H3.97a.387.387 0 0 1-.387-.387V1.738c0-.94.763-1.704 1.704-1.704h9.602c.941 0 1.704.763 1.704 1.704v1.007a.387.387 0 0 1-.387.387zM20 6.462v7.279c0 1.153-.938 2.09-2.09 2.09h-1.317v-3.097a2.79 2.79 0 0 0-2.788-2.788H6.371a2.79 2.79 0 0 0-2.788 2.788v3.098H2.267A2.093 2.093 0 0 1 .176 13.74v-7.28c0-1.152.938-2.09 2.09-2.09H17.91c1.153 0 2.091.938 2.091 2.09zM4.823 8.088a.93.93 0 1 0-1.86 0 .93.93 0 0 0 1.86 0zm9.911 4.646v4.337a.93.93 0 0 1-.929.929H6.371a.93.93 0 0 1-.93-.93v-4.336a.93.93 0 0 1 .93-.929h7.434a.93.93 0 0 1 .93.93z" />
                  </g>
                </g>
              </svg>
              <span v-if="!pdf_mergeing">{{
                $t("page_2.page_2_3.detail_1.btn_1")
                }}</span>

              <div v-if="pdf_mergeing" class="elastic-wrapp">
                <div class="dot-elastic"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-dialog v-model="share_screen" width="564px">
      <v-card color="universal-vcard">
        <div class="universal-vdialog-title">
          Dijeljenje datoteke sa strankom
        </div>
        <div class="full-width-popup-wrapp">
          <div class="form-autocomplete-add-wrapper">
            <form-autocomplete label="Dijeljene osobe" type="clanovi_tima" id="clanovi-tima-eventi" ref="assignedPeople"
              :placeholder="$t('forms.event.members_plh')" :items="to_share_with_able" :key="assigned_ppl_key"
              :invalid="false" :start="prev_assigned_people" :remove_all="true"></form-autocomplete>
          </div>

          <!-- <CustomMultiselectGeneral
            height="11rem"
            :id="'drop_reference'"
            :drop_items="to_share_with_able"
            :selected_items.sync="shared_with"
            init_text="Odaberite korisnike"
          /> -->
        </div>
        <div class="sifra-opis-wrapper">
          <!-- <v-textarea class="universal-vdialog-textfield" type="text"
                                placeholder="Opis tarifne stavke" label="Opis tarifne stavke"
                                v-model="new_suggestion.description"></v-textarea> -->
          <span class="opis-stavke-title">Naznaka</span>
          <ckeditor :editor="editor" v-model="share_description" :config="editorConfig">
          </ckeditor>
        </div>
        <div class="spiner-center-dialog" v-if="assign_ppl_loader">
          <CustomSpinner></CustomSpinner>
        </div>
        <div class="note-to-user">
          * Ukoliko želite produljiti pristup datoteci, odaberite opciju pohrani
          izmjene.<br />* Duljina trajanja svakog linka je 10 godina.
        </div>
        <div class="vdialog-buttons-wrapper">
          <div class="universal-vdialog-button vbutton-secondary" @click="share_screen = false">
            {{ $t("repetitive.cancel") }}
          </div>
          <div class="universal-vdialog-button vbutton-primary" @click="saveShareChanges()">
            Pohrani izmjene
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="delete_screen" width="564px">
      <v-card color="universal-vcard">
        <div class="universal-vdialog-title">
          {{ $t("page_2.page_2_3.delete_pop.title") }}
        </div>
        <div class="vdialog-buttons-wrapper wrapper-three-buttons">
          <div class="universal-vdialog-button vbutton-secondary" @click="delete_screen = false">
            {{ $t("repetitive.cancel") }}
          </div>
          <div class="universal-vdialog-button vbutton-primary" @click="deleteFile(activityFile.id)">
            {{ $t("page_2.page_2_3.delete_pop.btn_2") }}
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="newFolderPop" width="564px">
      <v-card color="universal-vcard">
        <div class="universal-vdialog-title">
          {{ $t("page_2.page_2_3.folder_pop.title") }}
        </div>
        <v-text-field class="universal-vdialog-textfield" label="Naziv foldera" v-model="newDirectoryName">
        </v-text-field>
        <div class="vdialog-buttons-wrapper">
          <div class="universal-vdialog-button vbutton-secondary" @click="newFolderPop = false">
            {{ $t("repetitive.cancel") }}
          </div>
          <div class="universal-vdialog-button vbutton-primary" @click="createFolder()">
            {{ $t("page_2.page_2_3.folder_pop.btn_2") }}
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="upload_fold_model" max-width="400">
      <v-card>
        <v-card-title class="text-h5">
          Odaberite folder za upload.
        </v-card-title>
        <tree-folders :key="refresher" :depth="0" :item="all_files_rec" :accessToken="accessToken"
          @node-click="setUploadFolder" :smjer="smjer"></tree-folders>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="blue darken-1" text @click="delete_screen = false">
            Odaberi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="renameFilePop" width="564px">
      <v-card color="universal-vcard">
        <div class="universal-vdialog-title" v-if="activityFile">
          {{ $t("page_2.page_2_3.rename_pop.title") }}
        </div>
        <v-text-field class="universal-vdialog-textfield" label="Naziv bez nastavka" v-model="new_file_name">
        </v-text-field>
        <div class="vdialog-buttons-wrapper">
          <div class="universal-vdialog-button vbutton-secondary" @click="renameFilePop = false">
            {{ $t("repetitive.cancel") }}
          </div>
          <div class="universal-vdialog-button vbutton-primary" @click="renameFile()">
            {{ $t("page_2.page_2_3.rename_pop.btn_2") }}
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-overlay :value="overlay">
      <div>{{ $t("page_2.page_2_3.print_txt") }}</div>
      <v-progress-linear color="light-blue darken-4" height="20" :value="overlay_progress" striped>
      </v-progress-linear>
    </v-overlay>

    <v-dialog v-model="move_spis" width="540" class="odaberite-spis-wrapper">
      <v-card>
        <div id="preseli-main-upload" class="upload-title odaberite-spis-title">
          {{ $t("page_2.page_2_4.spis_pop.title") }}
        </div>
        <div v-for="(sp, key) in move_dest" :key="key">
          <tree-folders :depth="0" :item="sp" :accessToken="accessToken" @node-click="setSpisFolder"
            :smjer="true"></tree-folders>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn color="deep-purple lighten-2" text @click="uploadFileToSpis()">
                  {{move_btn}}
                </v-btn> -->
          <div style="margin-top: 2.5rem" class="button-preseli-wrapper">
            <div class="button-default button-select-file" @click="uploadFileToSpis()">
              {{ move_btn }}
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="$store.state.spis_overlay_open" width="300">
      <DataLoader :is_on="pic_loading" />
      <div id="f-u-vuetify"></div>
      <img v-show="!pic_loading" :src="$store.state.spis_active_pic != null &&
          $store.state.spis_active_pic.thumbnails.length > 0
          ? $store.state.spis_active_pic.thumbnails[0].large.url
          : ''
        " @load="onImgLoad" />
    </v-dialog>
    <v-snackbar v-model="no_merge_snackbar" :timeout="snackTimeout" color="snack-custom-dark-blue" elevation="24">
      {{ $t("page_2.page_2_3.err_txt") }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="no_merge_snackbar = false">
          {{ $t("repetitive.okay") }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import share from "@/apiCallers/promise_handler_db/sharepoint";
import $ from "jquery";
import gsap from "gsap";
import TreeMenu from "@/components/generalComponents/TreeMenu.vue";
import moment from "moment";
import TreeFolders from "@/components/generalComponents/TreeFolders.vue";
import CaseTab from "@/components/caseComponents/CaseTab.vue";
import draggable from "vuedraggable";
import permissioner from "@/services/permissioner.js";
import DataLoader from "@/components/generalComponents/DataLoader";
import graph from "@/services/graph.js";
import CustomMultiselectGeneral from "@/components/generalComponents/CustomMultiselectGeneral.vue";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from "@/plugins/ckeditor_build";
import formAutocomplete from "@/components/formElements/formInputAutocomplete.vue";
import CustomSpinner from "@/components/generalComponents/CustomSpinner.vue";
const { PDFDocument } = require("pdf-lib");


import { downloadFilesAsZip } from "../../../helpers/file/index";
import FileMove from "./FileMove.vue";
// import EmailResponse from "../../email/EmailResponse.vue";
import FilterTagSwitch from "../../fileManagement/FilterTagSwitch.vue";
import fileTaggingHandler from "../../../apiCallers/promise_handler_db/fileTagging";
import { fileDownloadFinalization } from "../../../helpers/file/conversion";
import { switchGlobalLoaderMessage, switchGlobalLoaderState } from "../../../helpers/loader/global";
import https from "https";
import { mergeDLPDFs } from "../../../helpers/file/merger";

export default {
  components: {
    TreeMenu,
    TreeFolders,
    draggable,
    CaseTab,
    DataLoader,
    CustomMultiselectGeneral,
    ckeditor: CKEditor.component,
    "form-autocomplete": formAutocomplete,
    CustomSpinner,
    FileMove,
    // EmailResponse,
    FilterTagSwitch,
  },
  props: [
    "group_url",
    "folder_id",
    "view_name",
    "permission_starter",
    "selected_spis",
    "spis_hover",
    "movable",
    "move_dest",
    "group_type",
    "duplicatable",
    "name_filter",
    "no_empty",
    "can_share",
  ],
  data() {
    return {
      editor: ClassicEditor,

      editorConfig: {
        toolbar: {
          items: [
            "heading",
            "|",
            "bold",
            "italic",
            "link",
            "|",
            "undo",
            "redo",
            "|",
            "bulletedList",
            "numberedList",
            "texttransform",
          ],
        },
        link: {
          // Automatically add target="_blank" and rel="noopener noreferrer" to all external links.
          addTargetToExternalLinks: true,
        },
      },

      visible_copy_to_other_cases: false,
      assigned_ppl_key: 0,
      assign_ppl_loader: false,
      share_screen: false,
      assigned_people: { results_final: [] },
      prev_assigned_people: [],
      share_description: "",
      shared_with: [],
      to_share_with_able: [],
      previosly_shared: [],
      selected_share_obj: null,

      smjer: true,
      sort_type: 0,
      keyster_files: 1,
      move_spis: false,
      move_btn: this.$t("page_2.page_2_4.spis_pop.btn_1"),
      selected_spis_dir: null,

      //moving
      moving_file: {
        parentReference: {
          id: "",
        },
        name: "",
      },
      //SNACK PROPERTIES
      snackbar: false,
      snackTimeout: 10000,
      odbacene: [],
      snackText: "",
      //SNACK PROPERTIES
      //upload folder start
      newDirectoryName: "",
      newDirectoryParentId: "",
      newFolderPop: false,
      uploadNode: null,
      //upload folder end
      overlay: false,
      overlay_progress: 0,
      newFilePop: false,
      upload_fold_model: false,
      selected_upload_folder: {},
      order_by_tekst: this.$t("page_2.page_2_3.f_desc"),
      side_spis_view: false,
      treemenu_counter: 1,

      delete_screen: false,
      trigg: true,
      activityFile: null,
      multi_file_list: [],
      tree: {},
      accessToken: "",
      loading: false,
      selectedFolder: null,
      selectedFile: "",
      progress: 0,
      folders: [],
      predmet_info: { broj_predmeta: "" },
      rootSpisi: [],
      filelist: [],

      pdf_merge_file_list: [],
      flat_file_list: [],
      pdf_mergeing: false,

      file_upload_text: "Upload",
      is_waiting_on_insert: false,

      all_files_rec: null,

      all_files_rec_full_copy: null,
      opened_folder_arr: [],
      are_files_loaded: false,
      refresher: 1,

      new_file_name: "",
      renameFilePop: false,

      permission: {
        create: true,
        update: true,
        delete: true,
        read: true,
      },

      anim_duration: 0.5,
      //file handle rights

      mapped_case_permission: [],
      overlay_thumbnail: false,
      pic_loading: true,
      no_merge_snackbar: false,
      route_main_spis: "",
      sioVar: {
        type: {},
        required: false,
        default: null,
      },
      pdf_signing: false,

      is_spis_type: false,
      tagged_files: [],

      arrray_doc_type_filter: [],
    };
  },
  async created() {
    this.is_spis_type = this.$router["currentRoute"].path.includes("spisi");
    console.log("tag -2", this.tagged_files);
    this.accessToken = this.$store.state.aToken;
    console.log(this.$router["currentRoute"].path, "ruter");
    try {
      this.visible_copy_to_other_cases =
        this.$router["currentRoute"].path.includes("case");
    } catch {
      this.visible_copy_to_other_cases = false;
      console.log("Error while getting current route");
    }

    if (this.is_spis_type) {
      this.getTags();
    }

    // postaviti logiku side spis pogleda zavisno o varijabli
    this.side_spis_view = true;
    this.selected_upload_folder = this.folder_id;
    this.all_files_rec = await this.getRootSpisFile(this.folder_id);
    this.opened_folder_arr.push(this.folder_id);

    this.all_files_rec.children = await this.get_non_recursive_data(
      this.folder_id
    );
    if (this.no_empty === true) {
      this.all_files_rec.children = this.all_files_rec.children.filter(
        (p) => p.item.folder.childCount > 0
      );
    }

    for (let i = 0; i < this.all_files_rec.children.length; i++) {
      if (this.all_files_rec.children[i].item.folder != undefined) {
        this.all_files_rec.children[i].item["opened"] =
          this.opened_folder_arr.includes(
            this.all_files_rec.children[i].item.id
          );
        if (this.all_files_rec.children[i].item.folder.childCount > 0) {
          this.all_files_rec.children[i].children =
            await this.get_recursive_data(
              this.all_files_rec.children[i].item.id
            );
        } else {
          this.all_files_rec.children[i].children = [];
        }
      }
      // this.opened_folder_arr = [];
      this.keyster_files++;

      this.route_main_spis = this.folder_id;

      if (this.view_name == "spisi")
        this.$emit("merge-docs", this.pdf_merge_file_list);
    }
    this.are_files_loaded = true;
    // if (this.view_name == 'komunikacija') {
    this.$emit("loaded-docs", this.all_files_rec);
    this.filterSwitched([]);
    // }
    this.sioVar = this.$store.state.sioVar;
  },
  watch: {
    sioVar: function () {
      if (this.sioVar != null) {
        console.log("Dignuo gore socket listener");
        this.sioVar.socket.on("signer-message", async (data) => {
          this.pdf_signing = false;
          this.resetFileView();
        });
      }
    },
    share_screen: function (new_value) {
      if (!new_value) {
        this.assigned_people = { results_final: [] };
        // console.log("share_screen", new_value, this.assigned_people);
        this.assigned_ppl_key++;
      }
    },
    "$store.state.sioVar": function () {
      if (this.$store.state.sioVar != null) {
        this.sioVar = this.$store.state.sioVar;
      }
    },
    "$store.state.spis_overlay_open": {
      handler: function () {
        if (!this.$store.state.spis_overlay_open) {
          this.pic_loading = true;
        }
      },
    },
    "$store.state.all_files_tags": {
      handler: function () {
        if (!this.$store.state.all_files_tags) {
          this.tagged_files = this.$store.state.all_files_tags;
        }
      },
    },
    spis_hover: function () {
      this.folderHoverSpis(this.spis_hover);
    },
    move_spis: function () {
      if (this.move_spis == true) {
        this.selected_spis_dir = this.spisi_structure[0].item;
      } else {
        this.selected_spis_dir = null;
      }
    },
    overlay_thumbnail: {
      handler: function () {
        if (!this.overlay_thumbnail) {
          this.pic_loading = true;
        }
      },
    },
  },
  computed: {
    filtered_files: function () {
      if (this.name_filter == undefined) {
        return this.applyFilterTag()
      } else if (this.name_filter == "") {
        return this.applyFilterTag()
      } else {
        let tmp_list = {
          item: this.all_files_rec.item,
          children: this.all_files_rec.children.filter((item) =>
            item.item.name.toLowerCase().includes(this.name_filter)
          ),
        };
        // this.all_files_rec.children.forEach((item) => item.item.name.toLowerCase().includes(this.name_filter));
        return tmp_list;
      }
    },
    right_activity_file: function () {
      // The right activity is determined by values
      // 0 - Spis default
      if (
        this.all_files_rec != null &&
        this.activityFile == null &&
        this.multi_file_list.length == 0
      )
        return 0;
      // 1 - activity folder
      else if (
        this.activityFile != null &&
        this.activityFile.folder != undefined &&
        this.multi_file_list.length < 2
      )
        return 1;
      // 2 - activity file
      else if (
        this.all_files_rec != null &&
        this.activityFile != null &&
        this.activityFile.folder == undefined &&
        this.multi_file_list.length < 2
      )
        return 2;
      // 3 - multi select
      else if (this.multi_file_list.length > 0) return 3;
      else return 0;
    },
  },
  methods: {
    // Set file Filtering
    // 1. Check the filtered files array and check if the filtering is needed
    // 2. If there is need for filtering use recursive logic that can be occured withoud resetFileView method
    // 3. USe the flat mapped array of items and filter it using it

    // 4. After it is applied, compare the flat arrray recursively
    // Finish the logic

    // Note: make a flat copy

    filterTree(tree, condition, step = 1) {
      // Base case: if the tree is empty or undefined, return an empty array
      console.log("Step ", step, tree);
      if (!tree || tree.length === 0) {
        return [];
      }

      return tree
        .map((node) => {
          console.log("Node here", node);
          // Check if the current node passes the condition
          const passesCondition = condition(node);

          // Recursively filter children if they exist
          const filteredChildren = this.filterTree(
            node.children,
            condition,
            step + 1
          );
          console.log(
            "Filtered children",
            passesCondition,
            node.item.name,
            filteredChildren
          );

          // Include the node if it passes the condition OR has valid children
          if (passesCondition || filteredChildren.length > 0) {
            console.log("File passed the check", node);
            return {
              ...node,
              children: filteredChildren, // Update the children with filtered ones
            };
          }

          // Otherwise, exclude the node
          return null;
        })
        .filter((node) => node !== null); // Remove null values from the result
    },

    applyFilterToTree(accessible_file_array) {

      if (!this.all_files_rec || !this.all_files_rec.children) {
        console.warn("No files available to filter.");
        return;
      }

      // Define your filter condition here
      const condition = (node) => {
        if (node.item.folder) {
          console.log("Checking the node", node.item.folder);
          return true;
        } else {
          return accessible_file_array.includes(node.item.id);
        }
      };

      return this.filterTree(
        this.all_files_rec.children,
        condition
      );
      // Apply the filter recursively to the entire tree structure
      // console.log("Applied filter", this.filterTree(this.all_files_rec.children, condition));
    },
    filterSwitched(selected_tags) {
      this.arrray_doc_type_filter = selected_tags;

      this.$store.state.file_tag_filter = selected_tags;

      // tmp_file_list = tmp_file_list.filter(p=> this.$store.)
    },
    applyFilterTag() {
      const def_tag = this.$store.state.availableFileTags.slice(-1)[0];
      // this.all_files_rec_full_copy = [...this.all_files_rec];
      if (this.$store.state.file_tag_filter.length > 0) {
        // Init the full flat list
        let tmp_file_list = [...this.flat_file_list];


        let array_of_filtered_files = [];

        this.$store.state.file_tag_filter.forEach((p) => {
          if (p.id == def_tag.id) {
            // console.log("All files in db", this.flat_file_list.filter);
            const not_def = this.$store.state.all_files_tags
              .filter((sf) => sf.tag != p.id)
              .map((sf) => sf.file_id);
            let exception_arr = tmp_file_list.filter(
              (sf) => !not_def.includes(sf.id)
            );

            array_of_filtered_files = array_of_filtered_files.concat(
              exception_arr.map((item) => item.id)
            );
            console.log("Selected filter is default", not_def, exception_arr);
          } else {
            console.log(
              "Other filters",
              p,
              this.$store.state.all_files_tags.filter((sf) => sf.tag == p.id)
            );
            const temp_id_arr = this.$store.state.all_files_tags
              .filter((sf) => sf.tag == p.id)
              .map((sf) => sf.file_id);
            array_of_filtered_files =
              array_of_filtered_files.concat(temp_id_arr);
          }
        });
        console.log("Arr f files", array_of_filtered_files);
        const tmp_children = this.applyFilterToTree(array_of_filtered_files);
        return {
          item: this.all_files_rec.item,
          children: tmp_children
        }

      } else {
        return this.all_files_rec
      }
    },

    async getTags() {
      await fileTaggingHandler
        .getCaseFileTags(this.$route.params.uid)
        .then((resp) => {
          this.$store.state.all_files_tags = resp.data;
          // console.log('Got the tags', this.$store.state.all_files_tags)
        });
    },
    folderStatusChange(node) {
      console.log("Folder has been opened", node);
      if (this.opened_folder_arr.includes(node)) {
        this.opened_folder_arr = this.opened_folder_arr.filter(
          (p) => p != node
        );
      } else {
        this.opened_folder_arr.push(node);
      }
    },
    display_share_info() {
      if (!this.$store.state.current_selected_case) {
        return "";
      }
    },
    getUsersSharedWith(file_id) {
      if (!this.$store.state.current_selected_case) {
        return "";
      }
      // Get the shared file object from the store
      const sharedFile =
        this.$store.state.current_selected_case.client_portal_shared_file.find(
          (p) => p.item_id == file_id
        );

      // Check if the shared file exists
      if (!sharedFile) {
        console.log(`File with id ${file_id} not found.`);
        return "";
      }

      // Get the ids of the users that the file is shared with
      const userIds = sharedFile.phys_person_id;

      // Get the users from the store
      const users =
        this.$store.state.current_selected_case.connect_fiz_stranka.filter(
          (p) => userIds.includes(p.fizicka_osoba.uid)
        );

      // Map the users to a simpler format
      const formattedUsers = users.map(
        (user) => user.fizicka_osoba.ime + " " + user.fizicka_osoba.prezime
      );

      return formattedUsers.toString();
    },
    getSharedFileShareDate(file_id) {
      // Get the shared file object from the store
      if (!this.$store.state.current_selected_case) {
        return "";
      }
      const sharedFile =
        this.$store.state.current_selected_case.client_portal_shared_file.find(
          (p) => p.item_id == file_id
        );

      // Check if the shared file exists
      if (!sharedFile) {
        console.log(`File with id ${file_id} not found.`);
        return "";
      } else {
        moment.locale("hr");
        return moment(sharedFile.created_at).format("DD.MM.YYYY");
      }
      console.log(sharedFile);
    },
    getRemainderOfActiveYears(file_id) {
      // Get the shared file object from the store
      if (!this.$store.state.current_selected_case) {
        return "";
      }
      const sharedFile =
        this.$store.state.current_selected_case.client_portal_shared_file.find(
          (p) => p.item_id == file_id
        );

      // Check if the shared file exists
      if (!sharedFile) {
        console.log(`File with id ${file_id} not found.`);
        return "";
      } else {
        moment.locale("hr");
        let expiration_date = moment(sharedFile.expiration_date_time);
        if (expiration_date.diff(moment()) > 0) {
          return moment(sharedFile.expiration_date_time).fromNow(
            sharedFile.expiration_date_time
          );
        } else {
          return "Link za dijeljenje je neaktivan";
        }
      }
    },
    removeAllPeople() {
      this.prev_assigned_people = [];
      this.assigned_ppl_key++;
    },
    staggedEmitShare(file_id) {
      setTimeout(() => {
        this.emitShareDoc(file_id);
      }, 200);
    },
    emitShareDoc(file_id) {
      console.log("share_doc", file_id);
      // this.$emit("openSharePopup", file_id)

      this.resetShareState();
      this.populateShareWithAble();

      if (this.multi_file_list.length === 1) {
        this.setShareDescription(file_id);
      }

      this.setAssignedPeople();
      this.share_screen = true;

      this.assign_ppl_loader = false;
    },

    resetShareState() {
      this.shared_with = [];
      this.previosly_shared = [];
      this.share_description = "";
      this.prev_assigned_people = [];
      this.assigned_ppl_key++;
      this.assign_ppl_loader = true;
    },

    populateShareWithAble() {
      const caseData = this.$store.state.current_selected_case;
      const fizStranka = caseData.connect_fiz_stranka || [];
      const fizOstali = caseData.connect_fiz_ostali || [];

      this.to_share_with_able = [...fizStranka, ...fizOstali]
        .filter((p) => p.fizicka_osoba.username)
        .map((p) => ({
          iz_fiz: true,
          value: `${p.fizicka_osoba.ime} ${p.fizicka_osoba.prezime} - ${p.fizicka_osoba.username}`,
          tenance_mail: p.fizicka_osoba.username,
          link: p.fizicka_osoba.uid,
        }));
    },

    setShareDescription(file_id) {
      const caseData = this.$store.state.current_selected_case;
      const sharedFile = caseData.client_portal_shared_file.find(
        (p) => p.item_id === file_id
      );

      this.share_description = sharedFile ? sharedFile.description : "";
      console.log(sharedFile, "tmp_share");
    },

    setAssignedPeople() {
      const caseData = this.$store.state.current_selected_case;
      const sharedFileIDs = this.multi_file_list.map((p) => p.id);
      const sharedWith = caseData.client_portal_shared_file
        .filter((p) => sharedFileIDs.includes(p.item_id))
        .map((p) => p.phys_person_id)
        .flat();

      setTimeout(() => {
        this.assigned_people = this.$refs.assignedPeople.$data;
      }, 500);

      sharedWith.forEach((uid) => {
        const foundPerson = this.to_share_with_able.find((p) => p.link === uid);

        if (
          foundPerson &&
          !this.prev_assigned_people.some((p) => p.UID === foundPerson.link)
        ) {
          this.prev_assigned_people.push({
            UID: foundPerson.link,
            connection_status: undefined,
            is_fiz: true,
            name: foundPerson.value,
            status_ID: 1,
          });

          this.removeFromShareWithAble(foundPerson.link);
          this.assigned_ppl_key++;
          console.log("assigned changed", this.assigned_people);
        }
      });
    },

    removeFromShareWithAble(uid) {
      this.to_share_with_able = this.to_share_with_able.filter(
        (p) => p.link !== uid
      );
    },

    async saveShareChanges() {
      this.assign_ppl_loader = true;
      this.shared_with = this.assigned_people.results_final.map((p) => {
        return {
          naziv: p.name,
          id: p.UID,
        };
      });
      const { valuesToAdd, valuesToDelete } = this.compareArrays(
        this.shared_with,
        this.previosly_shared
      );
      for (let i = 0; i < this.multi_file_list.length; i++) {
        let single_file = this.multi_file_list[i];

        let tmp_share =
          this.$store.state.current_selected_case.client_portal_shared_file.find(
            (p) => p.item_id == single_file.id
          );

        let send_req_obj = {
          add_clients: valuesToAdd,
          remove_clients: valuesToDelete,
          final_clients_array: this.shared_with,
          file: {
            name: single_file.name,
          },
          description: this.share_description,
          permission_id: tmp_share ? tmp_share.id : null,
          send_email: this.multi_file_list.length == i + 1,
        };
        console.log("send_req_obj", send_req_obj);
        await share
          .shareSingleDoc(this.group_url, single_file.id, send_req_obj)
          .then((resp) => {
            this.$store.state.current_selected_case.client_portal_shared_file =
              resp.data;

            this.share_screen = false;
          });
      }
      this.assign_ppl_loader = false;
    },
    compareArrays(previouslySaved, newArray) {
      // Find values to delete
      const valuesToAdd = previouslySaved.filter(
        (item) => !newArray.includes(item)
      );

      // Find values to add
      const valuesToDelete = newArray.filter(
        (item) => !previouslySaved.includes(item)
      );

      return { valuesToDelete, valuesToAdd };
    },
    getFolderName(name) {
      switch (name.trim()) {
        case "Ulazni dokumenti":
        case "Ulazna pošta":
          return this.$t("page_2.page_2_5.fold_1");
        case "Izlazni dokumenti":
        case "Izlazna pošta":
          return this.$t("page_2.page_2_5.fold_2");
        case "Radni dokumenti":
          return this.$t("page_2.page_2_4.fold_2");
        case "Popratni dokumenti":
          return this.$t("page_2.page_2_4.fold_3");
        case "Naplata":
          return this.$t("page_2.page_2_7.fold_1");
        case "Računi":
          return this.$t("page_2.page_2_7.fold_2");
        default:
          return name;
      }
    },
    setSpisFolder(node) {
      this.selected_spis_dir = node;
    },
    async uploadFileToSpis() {
      $(".hovered-folder").removeClass("hovered-folder");
      if (this.multi_file_list.length == 0) {
        this.multi_file_list.push(node);
      }
      switchGlobalLoaderState(this.$t("components.file_management.sharepointUpload.uploading"))

      await fileDownloadFinalization(
        this.multi_file_list,
        this.$route.params.uid,
        this.selected_spis_dir
      )
        .then((resp) => {
          console.log("Uploaded all documents response", resp);
          if(resp.failed.length > 0){
            alert(this.$t("components.file_management.sharepointUpload.error", { files: resp.failed.join(", ") }));
          }
        })
        .finally(() => {
          this.move_spis = false;
          switchGlobalLoaderMessage(this.$t("components.file_management.sharepointUpload.success"));

          setTimeout(() => {
            this.multi_file_list = [];
            switchGlobalLoaderState()
          }, 2000);
         
        });
      // },
      //   this.multi_file_list = this.multi_file_list.filter(
      //     (item) => item.folder == undefined
      //   );
      //   let final_num = this.multi_file_list.length;
      //   let counter = 0;
      //   this.uploadSingleSpisFile(counter, final_num);
      // },
      // async uploadSingleSpisFile(counter, final_num) {
      //   this.accessToken = this.$store.state.aToken;
      //   this.move_btn = this.$t("page_2.page_2_4.spis_pop.btn_2", {
      //     curDoc: parseInt(counter + 1),
      //     finalLeng: final_num,
      //   });
      //   var tmp_file = this.multi_file_list[counter];
      //   let file_name_arr = tmp_file.name.split(".");
      //   let file_ext = file_name_arr[file_name_arr.length - 1];

      //   file_name_arr.pop();
      //   let final_name = file_name_arr.join("");

      //   let putanja = "";

      //   let new_path = "";

      //   if (
      //     file_ext == "jpg" ||
      //     file_ext == "jpeg" ||
      //     file_ext == "png" ||
      //     file_ext == "pdf"
      //   ) {
      //     //logic for non pdf
      //     new_path = tmp_file["@microsoft.graph.downloadUrl"];
      //   } else {
      //     putanja = tmp_file.parentReference.path.replace("/drive", "");

      //     new_path =
      //       "/drives/" +
      //       tmp_file.parentReference.driveId +
      //       putanja +
      //       "/" +
      //       encodeURIComponent(tmp_file.name);
      //   }
      //   let existing_number;
      //   await graph
      //     .checkFolderContainsFile(
      //       this.group_url,
      //       this.selected_spis_dir.id,
      //       final_name
      //     )
      //     .then((resp) => {
      //       existing_number = resp.value.length;
      //     });
      //   if (existing_number > 0) {
      //     final_name = final_name + " (" + existing_number + ")";
      //   }
      //   await share
      //     .convertToPDF(
      //       this.accessToken,
      //       this.group_url,
      //       this.selected_spis_dir.id,
      //       new_path,
      //       final_name,
      //       file_ext,
      //       this.$store.state.logged_in_user.uid,
      //       this.selected_spis_dir.name
      //     )
      //     .finally(() => {
      //       if (counter + 1 >= final_num) {
      //         this.move_spis = false;
      //         this.multi_file_list = [];
      //         alert(
      //           "Svi označeni dokumenti prebačeni su u odredište " +
      //             this.selected_spis_dir.name
      //         );
      //         this.move_btn = this.$t("page_2.page_2_4.spis_pop.btn_1");
      //       } else {
      //         this.uploadSingleSpisFile(parseInt(counter + 1), final_num);
      //       }
      //     })
      //     .catch(() => {
      //       //this.uploadSingleSpisFile(counter,final_num);
      //       console.log("Neuspjelo dohvaćan je datoteke ", final_name);
      //     });
    },
    preseliStyling() {
      this.move_spis = true;
      setTimeout(function () {
        var upl = document.getElementById("preseli-main-upload");
        $(upl.parentElement.parentElement).addClass(
          "file-upload-dialog-wrapper"
        );
        $(upl.parentElement).addClass("main-file-upload-wrapper");
        $(".spis-megawrapper").removeClass("active");
        $(".main-file-upload-wrapper").find(".spis-megawrapper:first").click();
      }, 100);
    },
    async copyFile() {
      this.currDirectory = [];
      this.progressActive = true;
      const lastIndex = this.activityFile.name.lastIndexOf(".");
      let existing_number = 0;
      let name_found = true;
      const before = this.activityFile.name.slice(0, lastIndex);
      const extension = this.activityFile.name.slice(lastIndex + 1);
      await graph
        .checkFolderContainsFile(
          this.$route.params.uid,
          this.activityFile.parentReference.id,
          before
        )
        .then((resp) => {
          existing_number = resp.value.length;
        });

      while (name_found) {
        await graph
          .checkFolderContainsFile(
            this.$route.params.uid,
            this.activityFile.parentReference.id,
            `${before} (${existing_number}).${extension}`
          )
          .then((resp) => {
            if (resp.value.length == 0) {
              name_found = false;
            } else {
              existing_number += 1;
            }
          });
      }

      const driveItem = {
        name: `${before} (${existing_number}).${extension}`,
      };
      share
        .copyFile(
          this.accessToken,
          this.$route.params.uid,
          this.activityFile.id,
          driveItem
        )
        .then(async (resp) => {
          this.resetFileView();
        });
    },
    onImgLoad() {
      this.pic_loading = false;
      setTimeout(() => {
        var getFuckingParent = document.getElementById("f-u-vuetify");
        $(getFuckingParent.parentElement).addClass("setDialogWidth");
      }, 10);
    },
    closeDetalji() {
      this.activityFile = null;
      this.multi_file_list = [];
      $(".eye_clicked").removeClass("eye_clicked");
      this.side_spis_view = true;
    },
    is_permission_inside(wanted_permission, assistent_check = true) {
      // 0 = case
      // 1 = project
      if (this.group_type == 0)
        return permissioner.check_case_permsision(
          this.permission_starter + "." + wanted_permission,
          assistent_check
        );
      else if (this.group_type == 1)
        return permissioner.check_project_permission(
          this.permission_starter + "." + wanted_permission
        );
      else if (this.group_type == 2 && wanted_permission == "read") return true;
      else return false;
    },

    openRenamePop() {
      var full_old_name = this.activityFile.name.split(".");
      full_old_name.pop();
      this.new_file_name = full_old_name.join(".");
      this.renameFilePop = true;
    },
    openFolderRenamePop() {
      var full_old_name = this.activityFile.name;
      this.new_file_name = full_old_name;
      this.renameFilePop = true;
    },
    //FOLDER DROP ON FOLDER
    moveFile(node) {
      $(".hovered-folder").removeClass("hovered-folder");

      if (this.multi_file_list.length == 0) {
        this.multi_file_list.push(node);
      }
      let move_counter = 0;
      for (let i = 0; i < this.multi_file_list.length; i++) {
        let active_move_file = this.multi_file_list[i];
        if (
          active_move_file.parentReference.id !=
          this.moving_file.parentReference.id &&
          this.moving_file.parentReference.id != ""
        ) {
          move_counter++;
          this.moving_file.name = active_move_file.name;
          var path = "/drive/items/" + active_move_file.id;
          share
            .moveDriveItem(
              this.accessToken,
              this.group_url,
              active_move_file.parentReference.id,
              path,
              this.moving_file
            )
            .then(() => {
              if (i + 1 == this.multi_file_list.length) {
                this.multi_file_list = [];
                if (
                  this.rootSpisi.findIndex(
                    (p) => p.id_spis == this.moving_file.parentReference.id
                  ) != -1
                ) {
                  setTimeout(async () => {
                    this.resetFileView();
                  }, 200);
                  setTimeout(async () => {
                    this.routeToSpis(this.moving_file.parentReference.id);
                  }, 200);
                } else {
                  setTimeout(async () => {
                    this.resetFileView();
                  }, 200);
                }
              }
            });
        } else {
          if (i + 1 == this.multi_file_list.length && move_counter > 0) {
            this.multi_file_list = [];
            setTimeout(async () => {
              this.resetFileView();
            }, 200);
          }
        }
      }
    },
    //FOLDER HOVER SET ACTIVE
    folderHover(node) {
      if (node == null) {
        this.moving_file.parentReference.id = "";
        this.moving_file.name = "";
      } else {
        this.moving_file.parentReference.id = node.id;
      }
    },
    folderHoverSpis(node) {
      if (node == null) {
        $("#" + this.moving_file.parentReference.id).removeClass(
          "hovered-over"
        );
        this.moving_file.parentReference.id = "";
        this.moving_file.name = "";
      } else {
        this.moving_file.parentReference.id = node.id_spis;
        $("#" + node.id_spis).addClass("hovered-over");
      }
    },

    //Rename activity file
    renameFile() {
      var idx_ext = this.activityFile.name.split(".").length - 1;
      var extension = this.activityFile.name.split(".")[idx_ext];
      var new_name_ext = this.new_file_name;
      if (this.activityFile.folder == undefined) {
        new_name_ext = this.new_file_name + "." + extension;
      }

      const driveItem = {
        name: new_name_ext,
      };
      share
        .renameSingleDoc(
          this.accessToken,
          this.group_url,
          this.activityFile.id,
          driveItem
        )
        .then((resp) => {
          this.activityFile = null;
          this.multi_file_list = [];
          this.renameFilePop = false;
          this.new_file_name = "";
          this.resetFileView();
        });
    },

    openUploadFolder() {
      this.$emit("uploadStyling");
    },

    //RESET OF DATA VIEW
    async resetFileView() {
      this.are_files_loaded = false;
      this.newFilePop = false;
      this.treemenu_counter++;
      this.tree.nodes = [];
      this.pdf_merge_file_list = [];
      // this.flat_file_list = this.treemenu_counter++;
      this.filelist = [];
      this.all_files_rec = await this.getRootSpisFile(this.folder_id);

      this.all_files_rec.children = await this.get_non_recursive_data(
        this.folder_id
      );
      if (this.no_empty === true) {
        this.all_files_rec.children = this.all_files_rec.children.filter(
          (p) => p.item.folder.childCount > 0
        );
      }

      this.side_spis_view = true;

      for (let i = 0; i < this.all_files_rec.children.length; i++) {
        if (this.all_files_rec.children[i].item.folder != undefined) {
          if (this.all_files_rec.children[i].item.folder.childCount > 0) {
            this.all_files_rec.children[i].children =
              await this.get_recursive_data(
                this.all_files_rec.children[i].item.id
              );
          } else {
            this.all_files_rec.children[i].children = [];
          }
        }
      }

      this.are_files_loaded = true;
      // this.opened_folder_arr = [];
      this.$emit("loaded-docs", this.all_files_rec);

      // let rec_data = await this.get_recursive_data(spis_id);
      // this.all_files_rec.children = rec_data;
      // this.all_files_rec = first_root;
    },

    //COLLECT ALL PDF-s and send them into mergeing process
    async spisToPDF() {
      if (this.pdf_merge_file_list.length == 0) {
        this.no_merge_snackbar = true;
      } else if (this.pdf_mergeing == false) {
        this.pdf_mergeing = true;
        await mergeDLPDFs(this.pdf_merge_file_list, this.selected_spis.ime).catch((error) => {
          alert(this.$t("components.general.error_merging"));
        }).finally(() => {
          this.pdf_mergeing = false;
        });
      }
    },
    // Add some visual fluff to show the user can drop its files
    dragover(event) {
      event.preventDefault();
      if (!event.currentTarget.classList.contains("bg-green-300")) {
        event.currentTarget.classList.remove("bg-gray-100");
        event.currentTarget.classList.add("bg-green-300");
        gsap.to(".loading-spinner", 0, { display: "block" });
        gsap.to(".loading-spinner", 0.5, { opacity: 1 });
        gsap.to(".drop-document-area", 0.5, {
          filter: "blur(3px)",
          opacity: 0.7,
        });
      }
    },
    // Clean up after cursor leaves
    dragleave(event) {
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-green-300");
      gsap.to(".loading-spinner", 0.5, { opacity: 0 });
      gsap.to(".drop-document-area", 0.5, { filter: "none", opacity: 1 });
    },
    //EVENT following dropping the files in area
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange(); // Trigger the onChange event manually
      // Clean up
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-green-300");
      //
      gsap.to(".loading-spinner", 0.5, { opacity: 0 });
      gsap.to(".drop-document-area", 0.5, { filter: "none", opacity: 1 });
    },
    // Reaction to event drop, that checks and controls all data
    onChange() {
      this.snackbar = false;
      //check all the inserted files and remove all that don't comply with pdf format START
      let tmp_file_list = [...this.$refs.file.files];
      let filt_tmp_file_list = tmp_file_list.filter(
        (file) => file.size < 57671680
      );
      const num_odbacenih = tmp_file_list.length - filt_tmp_file_list.length;
      if (num_odbacenih != 0) {
        this.snackbar = true;
        this.odbacene = tmp_file_list.filter((file) => file.size >= 57671680);
        this.snackText =
          "Zbog ograničenja Sharepoint-a odbačene su sljedeće datoteke veće od 55MB:";
      }
      tmp_file_list = filt_tmp_file_list;

      let pdf_tmp_file_list = tmp_file_list.filter((p) => {
        let tmp_name_list = p.name.split(".");
        return tmp_name_list[tmp_name_list.length - 1]
          .toLowerCase()
          .includes("pdf");
      });
      //check all the inserted files and remove all that don't comply with pdf format END
      const len_dif = tmp_file_list.length - pdf_tmp_file_list.length;
      if (len_dif > 0) {
        this.odbacene = [];
        this.snackbar = true;
        this.snackText =
          "Odbačeno je " + len_dif + " datoteka koje nisu PDF formata.";
      }
      tmp_file_list = pdf_tmp_file_list;
      if ([...this.$refs.file.files].length)
        this.filelist = this.filelist.concat(tmp_file_list);
    },
    //Remove file from list on X
    closePrint() {
      document.body.removeChild(this.__container__);
    },

    //
    setPrint() {
      contentWindow.__container__ = this;
      contentWindow.onbeforeunload = this.closePrint();
      contentWindow.onafterprint = this.closePrint();
      contentWindow.focus(); // Required for IE
      contentWindow.print();
    },
    reverseSmjer(id_filter) {
      // aktiviraj filter
      if (id_filter == 0) {
        //filter naziva
        $("#name-filter").addClass("active");
        $("#date-filter").removeClass("active");
      } else {
        // filter datuma
        $("#date-filter").addClass("active");
        $("#name-filter").removeClass("active");
      }

      // TweenMax.to('.open-folder-line-sort svg', 1, {rotation:360, ease:Linear.easeNone, repeat:-1})
      if ($("#tree-menu").height() > 960) {
        this.anim_duration = 0.4;
      } else {
        this.anim_duration = $("#tree-menu").height() * 0.00045;
      }

      // gsap.fromTo('#tree-menu',this.anim_duration,{height:0},{height:'auto', ease: "none"});
      gsap.to("#tree-menu", this.anim_duration, { height: 0, ease: "none" });
      setTimeout(async () => {
        if (id_filter == this.sort_type) {
          this.smjer = !this.smjer;
          if (this.smjer) {
            gsap.to(".svg-to-rotate", 0, { rotation: 0 });
            this.order_by_tekst = this.$t("page_2.page_2_3.f_desc");
          } else {
            gsap.to(".svg-to-rotate", 0, { rotation: 180 });
            this.order_by_tekst = this.$t("page_2.page_2_3.f_asc");
          }
        } else {
          this.sort_type = id_filter;
        }

        await this.resetFileView();
        gsap.fromTo(
          "#tree-menu",
          this.anim_duration,
          { height: 0 },
          { height: "auto", ease: "none" }
        );
      }, this.anim_duration * 1000);
    },
    openFile(linkToFile) {
      window.open(linkToFile);
    },
    async signFile(linkToFile) {
      this.pdf_signing = true;
      await share.sendToSign(
        linkToFile["@microsoft.graph.downloadUrl"],
        this.group_url,
        linkToFile.parentReference.id
      );
    },
    openSelectedFiles() {
      for (let i = 0; i < this.multi_file_list.length; i++) {
        window.open(this.multi_file_list[i].webUrl);
      }
    },
    downloadSingleFile() {
      window.open(this.multi_file_list[0]["@microsoft.graph.downloadUrl"]);
    },
    async downloadSelectedFiles() {
      // for (let i = 0; i < this.multi_file_list.length; i++) {
      //   window.open(this.multi_file_list[i]["@microsoft.graph.downloadUrl"]);
      // }
      const files = this.multi_file_list; // Example file array
      const customZipName = "FW-" + Date.now(); // Custom zip name

      // Call the global function to download the files as a zip
      await downloadFilesAsZip(files, customZipName);
    },
    deleteFile(fileId) {
      this.delete_screen = false;
      var path = "/drive/items/" + fileId;
      share.deleteFile(this.accessToken, this.group_url, path).then(() => {
        this.multi_file_list = [];
        this.side_spis_view = true;
        this.activityFile = null;
        this.resetFileView();
      });
    },
    logClick(node) {
      if (node.id === this.route_main_spis && this.view_name == "spisi") {
        this.activityFile = null;
        this.multi_file_list = [];
        // gsap.fromTo(".detalji-spisa", 0.3, { y: 50 }, { y: 0 });
      } else {
        this.activityFile = node;
        this.multi_file_list = [];
        this.multi_file_list.push(node);
        // this.getPreview();
        this.side_spis_view = false;
        //animacija za detalje spisa - da se signalizira da se nešto promijenilo
        gsap.fromTo(".detalji-spisa", 0.3, { y: 50 }, { y: 0 });
      }
    },
    nodeDrag(node) {
      // If it is inside start moving it
      let is_not_inside =
        this.multi_file_list.findIndex((p) => p.id == node.id) === -1;

      // If it is not inside then user started to drag file that has not been previously selected.
      if (is_not_inside) {
        this.multi_file_list = [];
        this.multi_file_list.push(node);
        $(".eye_clicked").removeClass("eye_clicked");
        $("#single-file-" + node.id).addClass("eye_clicked");
      }
    },
    setMultiFileSelection(node) {
      this.activityFile = null;
      // this.getPreview();
      this.side_spis_view = true;
      //animacija za detalje spisa - da se signalizira da se nešto promijenilo
      gsap.fromTo(".detalji-spisa", 0.3, { y: 50 }, { y: 0 });
      if (this.multi_file_list.length == 1) {
        if (this.multi_file_list[0].folder != undefined) {
          this.multi_file_list = [];
        }
      }

      let tmp_index = this.multi_file_list.findIndex((p) => {
        return p.id == node.id;
      });
      if (tmp_index == -1) {
        this.multi_file_list.push(node);
      } else {
        $("#single-file-" + node.id).removeClass("eye_clicked");
        this.multi_file_list.splice(tmp_index, 1);
      }
    },

    // CREATE FOLDER FUNCTIONS START
    handleFolderCreateFromFile(node) {
      let direcNameArray = node.name.split(".");
      if (direcNameArray.length > 1) {
        direcNameArray.pop();
      }
      let tmp_dir_name = direcNameArray.join("");
      this.newDirectoryName = tmp_dir_name;
      this.newFolderPop = true;
      this.newDirectoryParentId = node.parentReference.id;
      this.uploadNode = node;
    },
    //CREATE NEW FOLDER WHEN CLICKED ON ANOTHER FOLDER
    handleFolderCreateFromFolder(node) {
      this.newDirectoryName = "";
      this.newFolderPop = true;
      this.newDirectoryParentId = node.id;

      this.uploadNode = null;
    },
    //Connection to api that sends all necessery identifications and nodes to sharepoint site onedrive
    createFolder() {
      share
        .createFolderDocs(
          this.accessToken,
          this.group_url,
          this.newDirectoryParentId,
          this.newDirectoryName
        )
        .then((resp) => {
          if (this.uploadNode != null) {
            var path = "/drive/items/" + this.uploadNode.id;
            var tmpDriveItem = {
              parentReference: {
                id: resp.data.id,
              },
              name: this.uploadNode.name,
            };

            share
              .moveDriveItem(
                this.accessToken,
                this.group_url,
                resp.data.id,
                path,
                tmpDriveItem
              )
              .then(() => {
                this.resetFileView();
              });
          } else {
            this.resetFileView();
          }
          this.newFolderPop = false;
        });
    },
    // CREATE FOLDER FUNCTIONS END

    //inside upload form set the folder id
    setUploadFolder(node) {
      this.selected_upload_folder = node.id;
    },

    previewFiles() {
      var input = document.getElementById("myFiles");
      var file = input.files[0];
      share.addDocumentInSpis(
        this.accessToken,
        this.group_url,
        this.selectedFolder,
        file
      );
    },
    async addNewUploadFile() {
      if (this.filelist.length != 0) {
        const formData = new FormData();
        this.filelist.forEach((fl) => {
          formData.append("files", fl);
        });

        formData.append("token", this.accessToken);
        formData.append("groupId", this.group_url);
        formData.append("sid", this.selected_upload_folder);
        formData.append(
          "log_msg",
          "Dodaje datoteke u spisu " +
          this.selected_spis.ime +
          " - broj datoteka:" +
          this.filelist.length
        );
        formData.append("logged_uid", this.$store.state.logged_in_user.uid);
        // formData.append("name", esc_filename);
        // appending file
        this.file_upload_text = "Uploading...";
        this.is_waiting_on_insert = true;
        await share
          .addDocumentInSpis(formData)
          .then(() => {
            this.is_waiting_on_insert = false;
            this.file_upload_text = "Upload";
            this.resetFileView();
            document.getElementById("assetsFieldHandle").value = "";
          })
          .catch((err) => {
            this.is_waiting_on_insert = false;
            this.file_upload_text = "Upload";
            document.getElementById("assetsFieldHandle").value = "";
          });
      }
    },
    //PUSH ROUTE TO CASE SPIS BASED ON ID
    routeToSpis(sid) {
      this.$router.push("/case/" + this.group_url + "/spisi/" + sid);
      this.side_spis_view = true;
      this.activityFile = null;
    },

    //GET ALL DOCS IN DRIVE BASED ON drive id
    getAllDocsById(sid) {
      var ret_files = [];
      share
        .getDocumentsInSpis(this.accessToken, this.group_url, sid, this.smjer)
        .then((response) => {
          response.data.forEach((dat) => {
            ret_files.push(dat);
          });
        });

      return ret_files;
    },
    // DELETE ALL FILES IN SPIS
    deleteFileInSpis(file) {
      this.filelist = this.filelist.filter((f) => f != file);
    },
    // RETURN APPROPRIATE FILE ICON
    returnFileType(file_name) {
      var idx_ext = file_name.split(".").length - 1;
      var extension = file_name.split(".")[idx_ext].toLowerCase();
      var return_val = require("@/assets/img/doc_icon.svg");
      switch (extension) {
        case "docx":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "dotx":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "dotm":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "pptx":
          return_val = require("@/assets/img/ppt-icon.png");
          break;
        case "ppt":
          return_val = require("@/assets/img/ppt-icon.png");
          break;
        case "doc":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "pdf":
          return_val = require("@/assets/img/pdf_icon.svg");
          break;
        case "csv":
          return_val = require("@/assets/img/xls_icon.svg");
          break;
        case "xlsx":
          return_val = require("@/assets/img/xls_icon.svg");
          break;
        case "jpg":
          return_val = require("@/assets/img/jpg_icon.svg");
          break;
        case "jpeg":
          return_val = require("@/assets/img/jpg_icon.svg");
          break;
        case "png":
          return_val = require("@/assets/img/png_icon.svg");
          break;
        case "folder":
          return_val = require("@/assets/img/folder_yellow.svg");
          break;
        default:
          return_val = require("@/assets/img/dat_icon.svg");
          break;
      }
      return return_val;
    },
    //SWITCH TO NEW VIEW BY ROUTE
    switchTab(nastavak) {
      this.$router.push("/case/" + this.group_url + "/" + nastavak);
    },
    //APPROPRIATE DATE TIME FORMAT FOR DISPLAY
    switchDate(inData) {
      return moment(inData.toString()).format("lll");
    },
    //RETURNS FOLDER IN PARRENT DIRECTORY
    getfoldersById(sid) {
      var ret_fold = [];
      share
        .getDocumentsInSpis(this.accessToken, this.group_url, sid, this.smjer)
        .then((response) => {
          response.data.forEach((dat) => {
            if (dat.folder != undefined) {
              ret_fold.push(dat);
            }
          });
        });
      return ret_fold;
    },

    async get_non_recursive_data(id) {
      var ret_fold = [];
      moment.locale(this.$i18n.locale);
      this.accessToken = this.$store.state.aToken;
      await graph.getFileChildren(this.group_url, id).then(async (response) => {
        if (response.value.length > 0) {
          // selected_spis
          let tmp_arr_files = response.value;
          response.value.forEach((p) => {
            p["opened"] = this.opened_folder_arr.includes(p.id);
          });

          if (this.selected_spis != null) {
            tmp_arr_files = response.value.filter(
              (p) =>
                p.name.toString().toLowerCase().endsWith(".pdf") ||
                p.folder != undefined
            );
          }
          var collator = new Intl.Collator(undefined, {
            numeric: true,
            sensitivity: "base",
          });
          if (this.sort_type == 0) {
            if (this.smjer === true) {
              tmp_arr_files = tmp_arr_files.sort(function (a, b) {
                return collator.compare(a.name, b.name);
              });
            } else {
              tmp_arr_files = tmp_arr_files.sort(function (a, b) {
                return collator.compare(b.name, a.name);
              });
            }
          } else {
            if (this.smjer === true) {
              tmp_arr_files.sort(function (a, b) {
                let ret_val =
                  new Date(b.createdDateTime) - new Date(a.createdDateTime);
                return ret_val;
              });
            } else {
              tmp_arr_files.sort(function (a, b) {
                return (
                  new Date(a.createdDateTime) - new Date(b.createdDateTime)
                );
              });
            }
          }
          // tmp_arr_files.forEach(async (dat) => {
          for (var i = 0; i < tmp_arr_files.length; i++) {
            let tmp_ret_item = {
              item: tmp_arr_files[i],
              children: [],
            };
            if (tmp_arr_files[i].folder == undefined) {
              this.flat_file_list.push(tmp_arr_files[i]);
              this.pdf_merge_file_list.push(
                tmp_arr_files[i]["@microsoft.graph.downloadUrl"]
              );
            }
            ret_fold.push(tmp_ret_item);
          }

          // });
        }
      });
      return ret_fold;
    },

    //GET INITIAL
    async get_recursive_data(id) {
      var ret_fold = [];
      moment.locale(this.$i18n.locale);
      this.accessToken = this.$store.state.aToken;
      await graph.getFileChildren(this.group_url, id).then(async (response) => {
        if (response.value.length > 0) {
          let tmp_arr_files = response.value;

          if (this.selected_spis != null) {
            tmp_arr_files = response.value.filter(
              (p) =>
                p.name.toString().toLowerCase().endsWith(".pdf") ||
                p.folder != undefined
            );
          }
          var collator = new Intl.Collator(undefined, {
            numeric: true,
            sensitivity: "base",
          });
          if (this.sort_type == 0) {
            if (this.smjer === true) {
              tmp_arr_files = tmp_arr_files.sort(function (a, b) {
                return collator.compare(a.name, b.name);
              });
            } else {
              tmp_arr_files = tmp_arr_files.sort(function (a, b) {
                return collator.compare(b.name, a.name);
              });
            }
          } else {
            if (this.smjer === true) {
              tmp_arr_files.sort(function (a, b) {
                let ret_val =
                  new Date(b.createdDateTime) - new Date(a.createdDateTime);
                return ret_val;
              });
            } else {
              tmp_arr_files.sort(function (a, b) {
                return (
                  new Date(a.createdDateTime) - new Date(b.createdDateTime)
                );
              });
            }
          }
          // tmp_arr_files.forEach(async (dat) => {
          for (var i = 0; i < tmp_arr_files.length; i++) {
            let tmp_ret_item = {
              item: tmp_arr_files[i],
              children: [],
            };
            tmp_ret_item.item["opened"] = this.opened_folder_arr.includes(
              tmp_ret_item.item.id
            );
            if (tmp_arr_files[i].folder != undefined) {
              if (tmp_arr_files[i].folder.childCount > 0) {
                tmp_ret_item.children = await this.get_recursive_data(
                  tmp_arr_files[i].id
                );
              } else {
                tmp_ret_item.children = [];
              }
            } else {
              this.flat_file_list.push(tmp_arr_files[i]);
              this.pdf_merge_file_list.push(
                tmp_arr_files[i]["@microsoft.graph.downloadUrl"]
              );
            }
            ret_fold.push(tmp_ret_item);
          }

          // });
        }
      });
      return ret_fold;
    },
    async getRootSpisFile(sid) {
      let tmp_first = {
        item: {},
        children: [],
      };
      await graph.getSingleFile(this.group_url, sid).then(async (response) => {
        console.log(response);
        tmp_first.item = response;
        tmp_first.item["opened"] = true;
      });
      return tmp_first;
    },
  },
  mounted() {
    document.body.classList.add("spis-view");
    this.$store.state.file_tag_filter = [];
  },
  destroyed() {
    document.body.classList.remove("spis-view");
    setTimeout(() => {
      $(window).off();
    }, 1700);
  },
};
</script>

<style></style>
